<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-xl-5">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title mb-4">{{ $t('report.selection-element') }}</h4>
                        <p>{{ $t('report.checklist') }}</p>
                        <div role="tablist">
                            <b-card no-body class="mb-1">
                                <a
                                v-b-toggle.accordion-2
                                class="text-dark"
                                href="javascript: void(0);"
                                >
                                    <b-card-header header-tag="header" role="tab">
                                    <h6 class="m-0">
                                        {{ $t('report.private-data') }}
                                    </h6>
                                    </b-card-header>
                                </a>
                                <b-collapse id="accordion-2" visible accordion="my-accordion" role="tabpanel">
                                <b-card-body class="d-flex">
                                    <b-form-checkbox v-model="selectelement.citizen" switch class="mr-4" style="z-index:0;">
                                        <label>{{ $t('report.citizen-profile') }}</label>
                                    </b-form-checkbox>
                                    <b-form-checkbox v-model="selectelement.phone" switch class="mr-4" style="z-index:0;">
                                        <label>{{ $t('report.phone') }}/Email</label>
                                    </b-form-checkbox>
                                    <b-form-checkbox v-model="selectelement.tag" switch :disabled="selectelement.phone && tags != 0 ? false : true" class="mr-4" style="z-index:0;">
                                        <label>{{ $t('report.tag') }}</label>
                                    </b-form-checkbox>
                                </b-card-body>
                                </b-collapse>
                            </b-card>

                            <b-card no-body class="mb-1" v-if="id_template == 1 || id_template == 5">
                                <a
                                v-b-toggle.accordion-3
                                class="text-dark"
                                href="javascript: void(0);"
                                >
                                    <b-card-header header-tag="header" role="tab">
                                    <h6 class="m-0">
                                        {{ $t('report.related-image') }}
                                    </h6>
                                    </b-card-header>
                                </a>
                                <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                                <simplebar style="max-height: 500px;">
                                    <b-card-body>
                                        <b-form-checkbox v-model="selectelement.image.show" switch @change="clearRelationImage" class="mr-4" style="z-index:0;">
                                            <label> {{ $t('report.image-analysis') }}</label>
                                        </b-form-checkbox>
                                        <div v-if="selectelement.image.show">
                                            <p class="mx-0">{{ $t('report.select-image') }}</p>
                                            <div class="row">
                                                <div class="col-md-3 p-0" v-for="(m, index) in media" :key="index">
                                                    <div class="border border-1 border-dark rounded m-1">
                                                        <img v-if="m.source == 'instagram_img' || m.source == 'manual'" :src="getImage(m.image_name, m.path)" style="height:140px; max-width:140px;" class="img-fluid p-2" alt="Responsive image">
                                                        <img v-if="m.source == 'twitter'" :src="m.image_name == null ? m.path : getImage(m.image_name, m.path)" style="height:140px; max-width:140px;" class="img-fluid p-2" alt="Responsive image">
                                                        <div class="custom-control custom-checkbox" v-if="selectelement.image.list.length < 12 || selectelement.image.list.includes(m) ? true : false">
                                                            <input type="checkbox" class="custom-control-input" :id="'customCheck'+index" @click="selectImage(m)"/>
                                                            <label class="custom-control-label" :for="'customCheck'+index"><span class="sr-only">{{ $t('report.select') }}</span></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </b-card-body>
                                </simplebar>
                                </b-collapse>
                            </b-card>

                            <b-card no-body class="mb-1">
                                <a
                                v-b-toggle.accordion-0
                                class="text-dark"
                                href="javascript: void(0);"
                                >
                                    <b-card-header header-tag="header" role="tab">
                                    <h6 class="m-0">
                                        {{ $t('report.social-media') }}
                                    </h6>
                                    </b-card-header>
                                </a>
                                <b-collapse id="accordion-0" accordion="my-accordion" role="tabpanel">
                                <b-card-body class="d-flex">
                                    <b-form-checkbox v-model="selectelement.sosmed.twitter" switch class="mr-4" style="z-index:0;">
                                        <label>Twitter</label>
                                    </b-form-checkbox>
                                    <b-form-checkbox v-model="selectelement.sosmed.instagram" switch class="mr-4" style="z-index:0;">
                                        <label>Instagram</label>
                                    </b-form-checkbox>
                                    <b-form-checkbox v-model="selectelement.sosmed.telegram" switch class="mr-4" style="z-index:0;">
                                        <label>Telegram</label>
                                    </b-form-checkbox>
                                </b-card-body>
                                </b-collapse>
                            </b-card>
    
                            <!-- <b-card no-body class="mb-1">
                                <a
                                v-b-toggle.accordion-6
                                class="text-dark"
                                >
                                    <b-card-header header-tag="header" role="tab">
                                    <h6 class="m-0">
                                        {{ $t('report.timeline') }}
                                    </h6>
                                    </b-card-header>
                                </a>
                                <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
                                    <simplebar style="max-height: 450px;">
                                        <b-card-body>
                                            <b-form-checkbox switch v-model="selectelement.timeline.show" @change="clearTimeline" class="mr-4" style="z-index:0;">
                                                <label>{{ $t('report.timeline') }}</label>
                                            </b-form-checkbox>
                                            <div v-if="selectelement.timeline.show">
                                                <div class="row">
                                                    <div class="col-md-12 border rounded p-2 my-2" v-for="(all, index) in timeline" :key="index">
                                                        <h5 class="d-flex justify-content-between text-capitalize">
                                                            {{all.type}} - {{formatDate(all.date)}}
                                                            <div class="custom-control custom-checkbox">
                                                                <input type="checkbox" class="custom-control-input" :id="'checkTimeline'+index" @click="selectTimeline(all)"/>
                                                                <label class="custom-control-label" :for="'checkTimeline'+index"><span class="sr-only"> {{ $t('report.select') }}</span></label>
                                                            </div>
                                                        </h5>
                                                        <p class="text-justify">
                                                            <small>{{all.caption.substr(0, 274)}}</small>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </b-card-body>
                                    </simplebar>
                                </b-collapse>
                            </b-card> -->
                            
                            <!-- <b-card no-body class="mb-1">
                                <a
                                v-b-toggle.accordion-7
                                class="text-dark"
                                href="javascript: void(0);"
                                >
                                    <b-card-header header-tag="header" role="tab">
                                    <h6 class="m-0">
                                        {{ $t('report.relation-graph') }}
                                    </h6>
                                    </b-card-header>
                                </a>
                                <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
                                    <simplebar style="max-height: 450px;">
                                        <b-card-body>
                                            <b-form-checkbox switch v-model="selectelement.graph" class="mr-4" style="z-index:0;">
                                                <label>{{ $t('report.relation-graph') }}</label>
                                            </b-form-checkbox>
                                        </b-card-body>
                                        <img src="@/assets/images/graph.png" height="350px">
                                    </simplebar>
                                </b-collapse>
                            </b-card> -->

                            <!-- <b-card no-body class="mb-1">
                                <a
                                v-b-toggle.accordion-8
                                class="text-dark"
                                href="javascript: void(0);"
                                >
                                    <b-card-header header-tag="header" role="tab">
                                    <h6 class="m-0">
                                        Website
                                    </h6>
                                    </b-card-header>
                                </a>
                                <b-collapse id="accordion-8" accordion="my-accordion" role="tabpanel">
                                    <simplebar style="max-height: 450px;">
                                        <b-card-body class="d-flex">
                                            <b-form-checkbox switch v-model="selectelement.website.web" class="mr-4" style="z-index:0;">
                                                <label>{{ $t('report.website-info') }}</label>
                                            </b-form-checkbox>
                                            <b-form-checkbox switch v-model="selectelement.website.cms" :disabled="selectelement.website.web ? false : true" class="mr-4" style="z-index:0;">
                                                <label>{{ $t('report.cms-info') }}</label>
                                            </b-form-checkbox>
                                            <b-form-checkbox switch v-model="selectelement.website.whois" class="mr-4" style="z-index:0;">
                                                <label>{{ $t('report.whois-info') }}</label>
                                            </b-form-checkbox>
                                        </b-card-body>
                                    </simplebar>
                                </b-collapse>
                            </b-card> -->

                            <b-card no-body class="mb-1">
                                <a
                                v-b-toggle.accordion-12
                                class="text-dark"
                                href="javascript: void(0);"
                                >
                                    <b-card-header header-tag="header" role="tab">
                                    <h6 class="m-0">
                                        {{ $t('advanced.advanced-data') }}
                                    </h6>
                                    </b-card-header>
                                </a>
                                <b-collapse id="accordion-12" accordion="my-accordion" role="tabpanel">
                                    <b-card-body class="row">
                                        <b-form-checkbox switch v-model="selectelement.education.education" class="mr-4" style="z-index:0;" v-if="id_template == 1 || id_template == 5">
                                            <label>{{ $t('education.education') }}</label>
                                        </b-form-checkbox>
                                        <b-form-checkbox switch v-model="selectelement.education.career" class="mr-4" style="z-index:0;" v-if="id_template == 1 || id_template == 5">
                                            <label>{{ $t('education.career') }}</label>
                                        </b-form-checkbox>
                                        <!-- <b-form-checkbox switch v-model="selectelement.news.list" class="mr-4" style="z-index:0;">
                                            <label>{{ $t('report.news') }}</label>
                                        </b-form-checkbox> -->
                                        <b-form-checkbox switch v-model="selectelement.advanced.socmed" class="mr-4" style="z-index:0;" v-if="id_template == 1 || id_template == 5">
                                            <label>  {{ $t('advanced.social-media-database') }}</label>
                                        </b-form-checkbox>
                                        <b-form-checkbox switch v-model="selectelement.advanced.ecommerce" class="mr-4" style="z-index:0;" v-if="id_template == 1 || id_template == 5">
                                            <label>  {{ $t('advanced.ecommerce-database') }}</label>
                                        </b-form-checkbox>
                                        <b-form-checkbox switch v-model="selectelement.advanced.exposed" class="mr-4" style="z-index:0;" v-if="id_template == 1 || id_template == 5">
                                            <label>  {{ $t('advanced.exposed') }}</label>
                                        </b-form-checkbox>

                                            <b-form-checkbox switch v-model="selectelement.website.web" class="mr-4" style="z-index:0;">
                                            <label>{{ $t('report.website-info') }}</label>
                                        </b-form-checkbox>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>

                            <b-card no-body class="mb-1">
                                <a
                                v-b-toggle.accordion-10
                                class="text-dark"
                                href="javascript: void(0);"
                                >
                                    <b-card-header header-tag="header" role="tab">
                                    <h6 class="m-0">
                                        {{ $t('report.news') }}
                                    </h6>
                                    </b-card-header>
                                </a>
                                <b-collapse id="accordion-10" accordion="my-accordion" role="tabpanel">
                                    <simplebar style="max-height: 450px;">
                                        <b-card-body>
                                            <b-form-checkbox switch v-model="selectelement.news.show"  @change="clearNews" class="mr-4" style="z-index:0;">
                                                <label>{{ $t('report.news') }}</label>
                                            </b-form-checkbox>
                                            <div v-if="selectelement.news.show">
                                                <div class="row">
                                                    <div class="col-12 border rounded p-2 my-2" v-for="(all, index) in news" :key="index">
                                                    <div class="row">
                                                        <div class="col-3">
                                                            <img :src="all.image" alt="" srcset="" class="img-fluid" width="100%">
                                                        </div>
                                                    <div class="col-9">
                                                        <h6 class="d-flex justify-content-between text-capitalize">
                                                            {{all.title}} 
                                                            <div class="custom-control custom-checkbox">
                                                                <input type="checkbox" class="custom-control-input" :id="'checkNews'+index" @click="selectNews(all)"/>
                                                                <label class="custom-control-label" :for="'checkNews'+index"><span class="sr-only"> {{ $t('report.news') }}</span></label>
                                                            </div>
                                                        </h6>
                                                        <p class="text-justify">
                                                            <small>{{all.source}} - {{formatDate(all.published_at)}}</small>
                                                        </p>
                                                    </div>
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </b-card-body>
                                    </simplebar>
                                </b-collapse>
                            </b-card>

                            <b-card no-body class="mb-1">
                                <a
                                v-b-toggle.accordion-9
                                class="text-dark"
                                href="javascript: void(0);"
                                >
                                    <b-card-header header-tag="header" role="tab">
                                    <h6 class="m-0">
                                        {{ $t('report.social-network-analys') }}
                                    </h6>
                                    </b-card-header>
                                </a>
                                <b-collapse id="accordion-9" accordion="my-accordion" role="tabpanel">
                                    <simplebar style="max-height: 450px;">
                                        <b-card-body>
                                            <b-form-checkbox switch v-model="selectelement.sna" class="mr-4" style="z-index:0;"> Canvas
                                                <!-- {{ $t('report.social-network-analys') }} -->
                                            </b-form-checkbox>
                                        </b-card-body>
                                        <img src="@/assets/images/sna.png"  width="100%" class="p-5">
                                    </simplebar>
                                </b-collapse>
                            </b-card>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-7">
                <div class="card">
                    <div class="card-title">
                        <div class="d-flex justify-content-between d-print-none my-3 mx-2">
                            <h4 class="mx-2"> {{ $t('report.preview-report') }}</h4> 
                            <div class="float-right">
                                <button class="btn btn-success" @click="printReport">
                                <i class="fa fa-print" v-if="!loading.print"></i>
                                <i class="bx bx-loader-alt bx-spin" v-if="loading.print"></i>
                                </button>
                                <button role="button" @click="generateReport" class="btn btn-danger w-md ml-1">
                                    <i class="fa fa-file-pdf mr-1" v-if="!loading.generate"></i>
                                    <i class="bx bx-loader-alt bx-spin mr-1" v-if="loading.generate"></i>
                                    Download PDF
                                </button>
                            </div>
                        </div>
                    </div>
                    <simplebar style="max-height: 70vh;">
                        <div class="card-body">
                            <div class="invoice-title d-flex justify-content-between align-items-center">
                                    <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                    <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                            </div>
                            <hr class="mb-4" />
                            <h4 class="text-center mb-4 text-uppercase font-weight-bolder">{{ $t('report.target-profile') }}</h4>
                            <div class="row mt-4">
                                <div class="col-2 d-flex p-3">
                                    <img :src="urlimage+target.image_project" class="avatar-xl rounded-circle mr-4 " role="button"/>
                                </div>
                                <div class="col-7">
                                    <h4 class="mt-2 border-bottom border-primary">{{target.title}}</h4>
                                    <span><strong>{{ $t('report.category') }} </strong> <br> {{target.category == null ? '' : target.category.category_name}}</span>
                                    <div class="d-flex flex-column mt-1">
                                       <strong>{{ $t('report.description') }} </strong>
                                        <p class="text-justify">{{target.description}}</p>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <apexchart class="apex-charts" type="radialBar" height="180" :options="gaugeOptions" :series="gaugeSeries"></apexchart>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 mt-2">
                                    <strong>{{ $t('report.description-other') }}</strong>
                                    <p class="text-justify" v-html="target.other_description"></p>
                                </div>
                                <div class="col-12 mt-3">
                                    <div class="d-flex flex-column mt-1">
                                        <strong>{{ $t('report.relation-profile') }}</strong>
                                        <div class="team-member d-flex mt-1">
                                            <div class="container-fluid">
                                                <div class="row ">
                                                    <div class="col-2 mb-3 p-2 text-center border" v-for="(relation, index) in JSON.parse('['+target.relation_profile+']')" :key="index">
                                                        <span class="d-flex">
                                                            <img :title="relation.name" :src="urlimage+relation.image"  class="rounded-circle avatar-xs mx-auto" alt />
                                                        </span>
                                                        <span>{{relation.name}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>       
                            </div>
                            <!-- <div class="p-2 mt-3">
                            <h5 class="font-size-20 font-weight-bold">{{ $t('report.private-data') }}</h5>
                            </div>
                            <div class="table-responsive" v-if="selectelement.citizen">
                                <table class="table table-bordered">
                                    <thead>
                                    <tr>
                                        <th style="width: 70px;" colspan="3" class="text-left">{{ $t('report.citizen-profile') }}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <th width="25%">NIK</th>
                                        <td colspan="2">
                                            {{citizen == null ? '-' : citizen.nik }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t("overview.table.citizen.name") }}</th>
                                        <td colspan="2">
                                            {{citizen == null ? '-' : citizen.name}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t("overview.table.citizen.birth-place") }}, {{ $t("overview.table.citizen.date-of-birth") }}</th>
                                        <td colspan="2">{{citizen == null ? '-' : citizen.birth_place}}, {{citizen == null ? '-' : citizen.date_of_birth}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t("overview.table.citizen.gender") }}</th>
                                        <td colspan="2">{{citizen == null ? '-' : citizen.gender == 'L' ? 'Laki-laki' : 'Perempuan'}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t("overview.table.citizen.religion") }}</th>
                                        <td colspan="2">{{citizen == null ? '-' : citizen.religion}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t("overview.table.citizen.profession") }}</th>
                                        <td colspan="2">{{citizen == null ? '-' : citizen.profession == 0 ? 'Belum Bekerja' : '-'}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t("overview.table.citizen.nationality") }}</th>
                                        <td colspan="2" class="text-capitalize">{{citizen == null ? '-' : citizen.nationality}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t("overview.table.citizen.address") }}</th>
                                        <td colspan="2">{{citizen == null ? '-' : citizen.address}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            
                            <div v-if="selectelement.phone && private_data">
                                <div  class="html2pdf__page-break"/>
                                <div class="invoice-title pt-4 pb-1 d-flex justify-content-between align-items-center">
                                    <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                      <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                </div>
                                <hr class="mb-4" />
                                <div class="table-responsive" v-if="selectelement.phone && private_data">
                                    <table class="table table-bordered">
                                        <thead>
                                        <tr>
                                            <th style="width: 70px;" colspan="3" class="text-left">{{ $t('report.phone') }}/Email</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <th width="20%">Email</th>
                                            <td colspan="2">
                                                {{private_data ? private_data.email : "-"}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t('phone.phone-number') }}</th>
                                            <td colspan="2">{{private_data ? private_data.phone : "-"}}</td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t('phone.country-code') }}</th>
                                            <td colspan="2">{{private_data ? private_data.phone_country_code : "-"}}</td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t('phone.carrier') }}</th>
                                            <td colspan="2">{{private_data ? private_data.phone_carrier : "-"}}, {{private_data ? private_data.phone_location : "-"}}</td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t('phone.timezone') }}</th>
                                            <td colspan="2">{{private_data ? private_data.phone_timezone : "-"}}</td>
                                        </tr>
                                        <tr v-if="selectelement.tag && tags != 0">
                                            <th>{{ $t('report.tag') }}</th>
                                            <td colspan="2">
                                                <div class="row">
                                                    <div class="col-sm-3 my-auto pb-2" v-for="(tg, index) in JSON.parse(tags)" :key="index">
                                                            <b-button variant="outline-primary btn-block">{{tg}}</b-button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div> -->

                            <!-- private data -->
                            <section v-if="selectelement.citizen && selectelement.phone">
                                <div v-if="private_data || citizen" class="html2pdf__page-break"/>
                                    <div class="invoice-title pt-4 pb-1 d-flex justify-content-between align-items-center" v-if="private_data || citizen">
                                        <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                          <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                    </div>
                                <hr v-if="private_data || citizen" class="mb-4" />
                                <h4 class="text-center mb-4 text-uppercase font-weight-bolder" v-if="private_data || citizen">{{ $t('report.private-data') }}</h4>
                                <div class="table-responsive" v-if="selectelement.citizen">
                                    <table class="table table-bordered">
                                        <thead>
                                        <tr>
                                            <th style="width: 70px;" colspan="3" class="text-left h5 bg-secondary text-white">{{ $t('report.citizen-profile') }}</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <th width="25%">NIK</th>
                                            <td colspan="2">
                                                {{citizen == null ? '-' : citizen.nik }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t("overview.table.citizen.name") }}</th>
                                            <td colspan="2">
                                                {{citizen == null ? '-' : citizen.name}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t("overview.table.citizen.birth-place") }}, {{ $t("overview.table.citizen.date-of-birth") }}</th>
                                            <td colspan="2">{{citizen == null ? '-' : citizen.birth_place}}, {{citizen == null ? '-' : citizen.date_of_birth}}</td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t("overview.table.citizen.gender") }}</th>
                                            <td colspan="2">{{citizen == null ? '-' : citizen.gender == 'L' ? 'Laki-laki' : 'Perempuan'}}</td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t("overview.table.citizen.religion") }}</th>
                                            <td colspan="2">{{citizen == null ? '-' : citizen.religion}}</td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t("overview.table.citizen.profession") }}</th>
                                            <td colspan="2">{{citizen == null ? '-' : citizen.profession == 0 ? 'Belum Bekerja' : '-'}}</td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t("overview.table.citizen.nationality") }}</th>
                                            <td colspan="2" class="text-capitalize">{{citizen == null ? '-' : citizen.nationality}}</td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t("overview.table.citizen.address") }}</th>
                                            <td colspan="2">{{citizen == null ? '-' : citizen.address}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="table-responsive" v-if="selectelement.phone && private_data">
                                    <table class="table table-bordered">
                                        <thead>
                                        <tr>
                                            <th style="width: 70px;" colspan="3" class="text-left h5 bg-secondary text-white">{{ $t('report.phone') }}/Email</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <th width="25%">Email</th>
                                            <td colspan="2">
                                                {{private_data ? private_data.email : "-"}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t('phone.phone-number') }}</th>
                                            <td colspan="2">{{private_data ? private_data.phone : "-"}}</td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t('phone.country-code') }}</th>
                                            <td colspan="2">{{private_data ? private_data.phone_country_code : "-"}}</td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t('phone.carrier') }}</th>
                                            <td colspan="2">{{private_data ? private_data.phone_carrier : "-"}}, {{private_data ? private_data.phone_location : "-"}}</td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t('phone.timezone') }}</th>
                                            <td colspan="2">{{private_data ? private_data.phone_timezone : "-"}}</td>
                                        </tr>
                                        <tr v-if="selectelement.tag && tags != 0">
                                            <th>{{ $t('report.tag') }}</th>
                                            <td colspan="2">
                                                <div class="row">
                                                    <div class="col-sm-3 my-auto pb-2" v-for="(tg, index) in JSON.parse(tags)" :key="index">
                                                            <b-button variant="outline-secondary btn-block" size="xs" class="btn-sm">{{tg}}</b-button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </section>
                            
                            <div v-if="selectelement.image.show && selectelement.image.list[0]">
                                <div class="html2pdf__page-break"/>
                                <div class="invoice-title pt-4 pb-1 d-flex justify-content-between align-items-center">
                                    <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                      <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                </div>
                                <hr class="mb-4" />
                                <h4 class="text-center mb-4 text-uppercase font-weight-bolder">{{ $t('report.relation-image') }}</h4>
                                <div class="table-responsive">
                                    <table class="table table-bordered border">
                                        <thead>
                                            <tr>
                                                <th style="width: 70px;" class="text-center">{{ $t('report.image') }}</th>
                                                <th style="width: 70px;" colspan="2" class="text-center">{{ $t('report.image-noted') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(im, index) in selectelement.image.list" :key="index">
                                                <td width="30%" class="text-center">
                                                    <img v-if="im.source == 'twitter'" :src="im.image_name == null ? im.path : getImage(im.image_name, im.path)" style="height:180px; width:auto;" class="img-fluid border border-1 border-dark rounded" alt="Responsive image">
                                                    <img v-if="im.source == 'instagram_img' || im.source == 'manual'" :src="getImage(im.image_name, im.path)" style="height:180px; width:auto;" class="img-fluid border border-1 border-dark rounded " alt="Responsive image">
                                                </td>
                                                <td colspan="2">
                                                    <tr >
                                                        <td style="border:none;padding:5px;">{{ $t('report.source') }}</td>
                                                        <td style="border:none;padding:5px;">:</td>
                                                        <td v-if="im.source == 'instagram_img'" style="border:none;padding:5px;">Instagram</td>
                                                        <td v-else-if="im.source == 'twitter'" style="border:none;padding:5px;">Twitter</td>
                                                        <td v-else style="border:none;padding:5px;">{{ $t('report.image-manual-add') }}</td>
                                                    </tr>
                                                    <tr style="border:none;padding:5px;">
                                                        <td style="border:none;padding:5px;">{{ $t('report.image-noted') }}</td>
                                                        <td style="border:none;padding:5px;">:</td>
                                                        <td style="border:none;padding:5px;">
                                                            {{im.notes}}
                                                        </td>
                                                    </tr>
                                                    <tr style="border:none;padding:5px;">
                                                        <td style="border:none;padding:5px;">{{ $t('report.image-analytic-noted') }} </td>
                                                        <td style="border:none;padding:5px;">:</td>
                                                        <td style="border:none;padding:5px;">
                                                            {{im.analytic_notes}}
                                                        </td>
                                                    </tr>
                                                    <div class="html2pdf__page-break" v-if="index == 3 || index == 7 || index == 11"/>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <!-- social media -->
                            <section v-if="selectelement.sosmed.twitter || selectelement.sosmed.instagram || selectelement.sosmed.telegram">
                                <div v-if="twitter || instagram || telegram" class="html2pdf__page-break"/>
                                    <div class="invoice-title pt-4 pb-1 d-flex justify-content-between align-items-center" v-if="twitter || instagram || telegram">
                                        <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                          <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                    </div>
                                <hr v-if="twitter || instagram || telegram" class="mb-4" />
                                <h4 class="text-center mb-4 text-uppercase font-weight-bolder" v-if="twitter || instagram || telegram">{{ $t('report.social-media') }}</h4>
                                <div class="table-responsive" v-if="selectelement.sosmed.twitter">
                                    <table class="table table-bordered">
                                        <thead>
                                        <tr>
                                            <th style="width: 70px;" colspan="3" class="h5 bg-secondary text-white">Twitter </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <th width="25%">Avatar</th>
                                            <td colspan="2">
                                                <div>
                                                    <img
                                                        :src="twitter.avatar"
                                                        class="mr-3 rounded-circle avatar-sm"
                                                        alt="user-pic"
                                                        />
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th width="25%">Username</th>
                                            <td colspan="2">
                                                {{twitter == null ? '-' : twitter.account }}  <span v-if="twitter.verified == true"><i class="my-auto ml-1 text-primary mdi mdi-check-decagram mdi-18px"></i></span>

                                            </td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t("twitter.table.name") }}</th>
                                            <td colspan="2">
                                                {{twitter == null ? '-' : twitter.name}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t("twitter.table.followers") }}</th>
                                            <td colspan="2">{{twitter == null ? '-' : twitter.followers}}</td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t("twitter.table.following") }}</th>
                                            <td colspan="2">{{twitter == null ? '-' : twitter.following}}</td>
                                        </tr>
                                        <tr>
                                            <th>Bio</th>
                                            <td colspan="2">{{twitter == null ? '-' : twitter.bio}}</td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t("twitter.table.post") }}</th>
                                            <td colspan="2">{{twitter == null ? '-' : twitter.tweets}}</td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t("twitter.table.joint-at") }}</th>
                                            <td colspan="2">{{twitter == null ? '-' : formatDate(twitter.join_at)}}</td>
                                        </tr>
                                        <tr>
                                            <th> {{ $t("twitter.update") }} </th>
                                            <td colspan="2">{{twitter == null ? '-' : formatDate(twitter.updated_at)}}</td>
                                        </tr>
                                    
                                        </tbody>
                                    </table>
                                </div>

                                <div class="table-responsive" v-if="selectelement.sosmed.instagram">
                                    <table class="table table-bordered">
                                        <thead>
                                        <tr>
                                            <th style="width: 70px;" colspan="3" class="h5 bg-secondary text-white">Instagram</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <th width="25%">Avatar</th>
                                            <td colspan="2">
                                                <div>
                                                    <img
                                                        :src="avatar_ig+instagram.picture"
                                                        class="mr-3 rounded-circle avatar-sm"
                                                        alt="user-pic"
                                                        v-if="instagram.picture_hd"
                                                    />
                                                    <img :src="instagram.picture" alt="img" class="mr-3 rounded-circle avatar-sm" v-if="instagram.picture && !instagram.picture_hd">
                                                    <img
                                                        :src="theme == 'dark' ? 'https://img.icons8.com/ios/240/FFFFFF/user-male-circle.png' : 'https://img.icons8.com/ios/240/000000/user-male-circle.png'"
                                                        class="mr-3 rounded-circle avatar-sm"
                                                        alt="user-pic" v-if="!instagram.picture && !instagram.picture_hd"
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th width="25%">Username</th>
                                            <td colspan="2">
                                                {{instagram == null ? '-' : instagram.account }} 
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t("twitter.table.name") }}</th>
                                            <td colspan="2">
                                                {{instagram == null ? '-' : instagram.full_name}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Bio</th>
                                            <td colspan="2">{{instagram == null ? '-' : instagram.bio}}</td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t("instagram.followers") }}</th>
                                            <td colspan="2">{{instagram == null ? '-' : instagram.followers}}</td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t("instagram.following") }}</th>
                                            <td colspan="2">{{instagram == null ? '-' : instagram.following}}</td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t("instagram.post") }}</th>
                                            <td colspan="2">{{instagram == null ? '-' : instagram.media}}</td>
                                        </tr>
                                        <tr>
                                            <th>Category</th>
                                            <td colspan="2">{{instagram == null ? '-' : instagram.category_name}}</td>
                                        </tr>
                                        <tr>
                                            <th> {{ $t("instagram.update") }} </th>
                                            <td colspan="2">{{instagram == null ? '-' : formatDate(instagram.updated_at)}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div class="table-responsive" v-if="selectelement.sosmed.telegram">
                                    <table class="table table-bordered">
                                        <thead>
                                        <tr>
                                            <th style="width: 70px;" colspan="3" class="h5 bg-secondary text-white">Telegram</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <th width="25%">Username</th>
                                            <td colspan="2">
                                                {{telegram.account == null ? '-' : telegram.account }} 
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t("overview.table.all.first_name") }}</th>
                                            <td colspan="2">
                                                {{telegram.first_name == null ? '-' : telegram.first_name}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t("overview.table.all.last_name") }}</th>
                                            <td colspan="2">{{telegram.last_name == null ? '-' : telegram.last_name}}</td>
                                        </tr>
                                        <tr>
                                            <th>{{ $t("overview.table.all.phone") }}</th>
                                            <td colspan="2">{{telegram.phone == null ? '-' : telegram.phone}}</td>
                                        </tr>
                                        <tr>
                                            <th> {{ $t("instagram.update") }} </th>
                                            <td colspan="2">{{telegram.updated_at == null ? '-' : formatDate(telegram.updated_at)}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </section>

                            <div v-if="selectelement.timeline.show">
                                <div class="html2pdf__page-break"/>
                                <div class="invoice-title pt-4 pb-1 d-flex justify-content-between align-items-center">
                                    <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                      <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                </div>
                                <hr class="mb-4" />
                                <h4 class="text-center mb-4 text-uppercase font-weight-bolder">{{ $t('report.social-media') }}</h4>
                                <div class="">
                                    <p>{{ $t('report.other-medsos')}}</p>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <ol class="list-group-numbered">
                                                <li class="h5 font-weight-bold">Twitter</li>
                                                <div class="table-responsive">
                                                    <table class="table table-bordered">
                                                        <tr>
                                                            <td width="20%">{{ $t('twitter.table.account') }}</td>
                                                            <td>{{twitter.account}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="20%">{{ $t('twitter.table.name') }}</td>
                                                            <td>{{twitter.name}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="20%">{{ $t('twitter.table.followers') }}</td>
                                                            <td>{{twitter.followers}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="20%">{{ $t('twitter.table.following') }}</td>
                                                            <td>{{twitter.following}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="20%">{{ $t('twitter.table.join-at') }}</td>
                                                            <td>{{twitter.join_at}}</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                <li class="h5 font-weight-bold">Instagram</li>
                                                <div class="table-responsive">
                                                    <table class="table table-bordered">
                                                        <tr>
                                                            <td width="20%">{{ $t('instagram.account') }}</td>
                                                            <td>{{instagram.account}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="20%">{{ $t('instagram.full_name') }}</td>
                                                            <td>{{instagram.full_name}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="20%">Bio</td>
                                                            <td>{{instagram.bio}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="20%">{{ $t('instagram.followers') }}</td>
                                                            <td>{{instagram.followers}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="20%">{{ $t('instagram.following') }}</td>
                                                            <td>{{instagram.following}}</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                <div v-if="private_web != 0 && private_web">
                                                    <li class="h5 font-weight-bold">Website</li>
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <tr>
                                                                <td width="20%">{{ $t('website.domain_name') }}</td>
                                                                <td>{{private_web.domain}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td width="20%">{{ $t('website.ip') }}</td>
                                                                <td>{{private_web.ip_address}} </td>
                                                            </tr>
                                                            <tr>
                                                                <td width="20%">{{ $t('website.ip_location') }}</td>
                                                                <td>{{private_web.hosting_country}} ({{private_web.ip_location}})</td>
                                                            </tr>
                                                            <tr>
                                                                <td width="20%">{{ $t('website.hosting_company') }}</td>
                                                                <td>{{private_web.hosting_company}} </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="selectelement.timeline.list.length > 0">
                                    <div class="html2pdf__page-break"/>
                                    <div class="invoice-title px-0 pt-4 pb-1 d-flex justify-content-between align-items-center">
                                        <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                          <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                    </div>
                                    <hr class="mb-4" />
                                    <div class="">
                                        <table class="table table-bordered">
                                            <thead>
                                            <tr>
                                                <th style="border-top: none;" colspan="2" class="h5">{{ $t('report.timeline-list') }}</th>
                                            </tr>
                                            <tr>
                                                <th width="15%" class="text-center">{{ $t('report.media') }}</th>
                                                <th width="85%" class="text-center">{{ $t('report.post') }}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(tm, index) in selectelement.timeline.list" :key="index">
                                                    <td class="px-4 text-center align-middle" width="20%">
                                                        <span class="font-weight-bold text-capitalize">{{tm.type}}</span>
                                                    </td>
                                                    <td >
                                                        <tr>
                                                            <td style="border:none; padding:5px;">{{ $t('report.content') }}</td>
                                                            <td style="border:none;padding:5px;">:</td>
                                                            <td style="border:none;padding:5px;word-break:break-word;white-space: pre-line;overflow-wrap: break-word;-ms-word-break: break-word;word-break: break-word;" class="text-justify">{{tm.caption}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style="border:none;padding:5px;">{{ $t('report.created-at') }}</td>
                                                            <td style="border:none;padding:5px;">:</td>
                                                            <td style="border:none;padding:5px;">
                                                                {{formatDate(tm.date)}}
                                                            </td>
                                                        </tr>
                                                        <tr style="border:none;">
                                                            <td style="border:none;padding:5px;">{{ $t('report.link') }}</td>
                                                            <td style="border:none;padding:5px;">:</td>
                                                            <td style="border:none;padding:5px; word-break:break-word;white-space: pre-line;overflow-wrap: break-word;-ms-word-break: break-word;word-break: break-word;">
                                                                {{tm.link}}
                                                            </td>
                                                        </tr>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <section v-if="selectelement.graph">
                                <div class="html2pdf__page-break"/>
                                <div class="invoice-title pt-4 pb-1 d-flex justify-content-between align-items-center">
                                    <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                      <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                </div>
                                <hr class="mb-4" />
                                <h4 class="text-center mb-4 text-uppercase font-weight-bolder">{{ $t('report.relation-graph')}}</h4>
                                <div class="mt-4">
                                    <cytoscape
                                        v-if="dataRelation && dataWordCloud && dataFollow && dataMention"
                                        ref="cyRef"
                                        :afterCreated="afterCreated"
                                        :preConfig="preConfig"
                                        :config="config">
                                    </cytoscape>
                                </div>
                            </section>
                            <!-- 
                            <section v-if="selectelement.website.web && webinfo">
                                <div class="html2pdf__page-break"/>
                                <div class="invoice-title pt-4 pb-1 d-flex justify-content-between align-items-center">
                                    <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                      <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                </div>
                                <hr class="mb-4" />
                                <h4 class="text-center mb-4 text-uppercase font-weight-bolder">{{ $t('website.website-info') }}</h4>
                                <p class="h4">Website :  {{webinfo.domain_name}}</p>
                                <div class="mt-4 d-flex">
                                    <div class="w-100">
                                        <div class="table-responsive pr-2">
                                            <table class="table table-bordered w-100">
                                                <thead>
                                                    <tr>
                                                        <th colspan="2" class="h5 bg-secondary text-white">{{ $t('website.basic-info') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.ip_address') }}</th>
                                                        <td class="p-2">{{webinfo.ip_address}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.visitors') }}</th>
                                                        <td class="p-2">{{webinfo.visitors}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.ip_location') }}</th>
                                                        <td class="p-2">{{webinfo.ip_location}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.ip_reserve_dns') }}</th>
                                                        <td class="p-2">{{webinfo.ip_reverse_dns}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.hosting_company') }}</th>
                                                        <td class="p-2">{{webinfo.hosting_company}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.hosting_ip_range') }}</th>
                                                        <td class="p-2">{{webinfo.hosting_ip_range}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.hosting_address') }}</th>
                                                        <td class="p-2">{{webinfo.hosting_address}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.hosting_country') }}</th>
                                                        <td class="p-2">{{webinfo.hosting_country}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.hosting_phone') }}</th>
                                                        <td class="p-2">{{webinfo.hosting_phone}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">CIDR</th>
                                                        <td class="p-2">{{webinfo.cidr}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.hosting_cidr') }}</th>
                                                        <td class="p-2">{{webinfo.hosting_cidr}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="table-responsive pr-2">
                                            <table class="table table-bordered w-100">
                                                <thead>
                                                    <tr>
                                                        <th colspan="2" class="h5 bg-secondary text-white">{{ $t('website.geografis-info') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.region') }}</th>
                                                        <td class="p-2">{{iplocation.region}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.country_name') }}</th>
                                                        <td class="p-2">{{iplocation.country_name}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.postal') }}</th>
                                                        <td class="p-2">{{(iplocation.postal_code)}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.latitude') }}</th>
                                                        <td class="p-2">{{iplocation.latitude}},  {{iplocation.longitude}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.timezone') }}</th>
                                                        <td class="p-2">{{iplocation.timezone}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="w-100">
                                        <div class="table-responsive pl-2">
                                            <table class="table table-bordered w-100">
                                                <thead>
                                                    <tr>
                                                        <th colspan="2" class="h5 bg-secondary text-white">{{ $t('website.ip') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>  
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.ip') }}</th>
                                                        <td class="p-2">{{iplocation.ip_address}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.domain_name') }}</th>
                                                        <td class="p-2">{{iplocation.domain_name}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.version') }}</th>
                                                        <td class="p-2">{{iplocation.version}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.city') }}</th>
                                                        <td class="p-2">{{iplocation.city}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.region') }}</th>
                                                        <td class="p-2">{{iplocation.region}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.region_code') }}</th>
                                                        <td class="p-2">{{iplocation.region_code}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.country_name') }}</th>
                                                        <td class="p-2">{{iplocation.country_name}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.country_code') }}</th>
                                                        <td class="p-2">{{iplocation.country_code}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.country_code_iso3') }}</th>
                                                        <td class="p-2">{{iplocation.country_code_iso3}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.country_tld') }}</th>
                                                        <td class="p-2">{{iplocation.country_tld}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.continent_code') }}</th>
                                                        <td class="p-2">{{iplocation.continent_code}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.continent_code') }}</th>
                                                        <td class="p-2">{{iplocation.continent_code}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.currency') }}</th>
                                                        <td class="p-2">{{iplocation.currency}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.currency_name') }}</th>
                                                        <td class="p-2">{{iplocation.currency_name}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.languages') }}</th>
                                                        <td class="p-2">{{iplocation.languages}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.country_area') }}</th>
                                                        <td class="p-2">{{iplocation.country_area}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">ASN</th>
                                                        <td class="p-2">{{iplocation.asn}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">ORG</th>
                                                        <td class="p-2">{{iplocation.org}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </section> -->

                            <section v-if="selectelement.website.cms && selectelement.website.web && cms">
                                <div class="html2pdf__page-break"/>
                                <div class="invoice-title pt-4 pb-1 d-flex justify-content-between align-items-center">
                                    <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                      <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                </div>
                                <hr class="mb-4" />
                                <div class="mt-4 d-flex">
                                    <div class="w-100">
                                        <div class="table-responsive pr-2">
                                            <table class="table table-bordered w-100">
                                                <thead>
                                                    <tr>
                                                        <th colspan="2" class="h5 bg-secondary text-white">{{ $t('website.cms-info') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th class="h5 p-2" colspan="2">CMS</th>
                                                    </tr>
                                                    <tr v-for="(data, index) in JSON.parse(cms.result)" :key="index">
                                                        <td class="p-2">{{data.name}}</td>
                                                        <td class="p-2">{{data.categories[0]}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="h5 p-2" colspan="2">{{ $t('website.social-media') }}</th>
                                                    </tr>
                                                    <tr v-for="(data, index) in JSON.parse(cms.social_media)" :key="index">
                                                        <td class="text-capitalize p-2">{{data.network}}</td>
                                                        <td class="p-2">{{data.profile}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <!-- <table class="table table-bordered w-100">
                                                <thead>
                                                    <tr>
                                                        <th colspan="2" class="h4 bg-secondary text-white">Open Web Service</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(s,index) in service" :key="index">
                                                        <th>{{service[index]}}</th>
                                                        <td>{{s[1]}}</td>
                                                    </tr>
                                                </tbody>
                                            </table> -->
                                        </div>
                                    </div>
                                    <div class="w-100">
                                        <div class="table-responsive pl-2">
                                            <table class="table table-bordered w-100">
                                                <thead>
                                                    <tr>
                                                        <th colspan="2" class="h4 bg-secondary text-white">Sub Domain {{ $t('website.sub-domain') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(data, index) in JSON.parse(subdomain)" :key="index">
                                                        <td class="p-2">{{data.subdomain}}</td>
                                                        <td class="p-2">{{data.ip}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <section v-if="selectelement.website.whois && whois">
                                <div class="html2pdf__page-break"/>
                                <div class="invoice-title pt-4 pb-1 d-flex justify-content-between align-items-center">
                                    <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                      <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                </div>
                                <hr class="mb-4" />
                                <h4 class="text-center mb-4 text-uppercase font-weight-bolder">{{ $t('website.whois-info') }}</h4>
                                <table>
                                    <tr>
                                        <td>{{ $t('website.domain_name') }} </td>
                                        <td class="px-2">:</td>
                                        <td>{{whois != 0 ? whois.domain_name : "-" }}</td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('website.created_date') }} </td>
                                        <td class="px-2">:</td>
                                        <td>{{whois != 0 ? whois.created_date : "-" }}</td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('website.expired_date') }} </td>
                                        <td class="px-2">:</td>
                                        <td>{{whois != 0 ? whois.expired_date : "-" }}</td>
                                    </tr>
                                    <tr>
                                        <td>Email </td>
                                        <td class="px-2">:</td>
                                        <td>{{whois != 0 ? whois.contact_email : "-" }}</td>
                                    </tr>
                                </table>
                                <div class="mt-4 d-flex">
                                    <div class="w-100">
                                        <div class="table-responsive pr-2">
                                            <table class="table table-bordered w-100">
                                                <tbody>
                                                    <tr>
                                                        <th colspan="2" class="h5 bg-secondary text-white">{{ $t('website.registran') }}</th>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.registran_name') }}</th>
                                                        <td class="p-2">{{whois != 0 ? whois.registran_name : "-" }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{$t('website.registrant_organization')}}</th>
                                                        <td class="p-2">{{whois != 0 ? whois.registran_organization : "-" }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{$t('website.registran_street')}}</th>
                                                        <td class="p-2">{{whois != 0 ? whois.registran_street : "-" }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{$t('website.registran_city')}}</th>
                                                        <td class="p-2">{{whois != 0 ? whois.registran_city : "-" }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{$t('website.registran_country')}}</th>
                                                        <td class="p-2">{{whois != 0 ? whois.registran_country : "-" }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{$t('website.registran_country_code')}}</th>
                                                        <td class="p-2">{{whois != 0 ? whois.registrant_countryCode : "-" }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{$t('website.registran_phone')}}</th>
                                                        <td class="p-2">{{whois != 0 ? whois.registran_phone : "-" }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{$t('website.registran_fax')}}</th>
                                                        <td class="p-2">{{whois != 0 ? whois.registran_fax : "-" }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="w-100">
                                        <div class="table-responsive pl-2">
                                            <table class="table table-bordered w-100">
                                                <tbody>
                                                    <tr>
                                                        <th colspan="2" class="h4 bg-secondary text-white">Admin</th>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{$t('website.admin_name')}}</th>
                                                        <td class="p-2">{{whois != 0 ? whois.admin_name : "-" }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{$t('website.admin_organization')}}</th>
                                                        <td class="p-2">{{whois != 0 ? whois.admin_organization : "-" }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{$t('website.registran_phone')}}</th>
                                                        <td class="p-2">{{whois != 0 ? whois.admin_street : "-" }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{$t('website.admin_city')}}</th>
                                                        <td class="p-2">{{whois != 0 ? whois.admin_city : "-" }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{$t('website.admin_phone')}}</th>
                                                        <td class="p-2">{{whois != 0 ? whois.admin_phone : "-" }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{$t('website.admin_fax')}}</th>
                                                        <td class="p-2">{{whois != 0 ? whois.admin_fax : "-" }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="table-responsive pl-2">
                                            <table class="table table-bordered w-100">
                                                <tbody>
                                                    <tr>
                                                        <th colspan="2" class="h4 bg-secondary text-white">Tech</th>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{$t('website.tech_organization')}}</th>
                                                        <td class="p-2">{{whois != 0 ? whois.tech_name : "-" }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{$t('website.tech_organization')}}</th>
                                                        <td class="p-2">{{whois != 0 ? whois.tech_organization : "-" }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{$t('website.tech_fax')}}</th>
                                                        <td class="p-2">{{whois != 0 ? whois.tech_street : "-" }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{$t('website.tech_city')}}</th>
                                                        <td class="p-2">{{whois != 0 ? whois.tech_city : "-" }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{$t('website.tech_email')}}</th>
                                                        <td class="p-2">{{whois != 0 ? whois.tech_email : "-" }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{$t('website.tech_fax')}}</th>
                                                        <td class="p-2">{{whois != 0 ? whois.tech_fax : "-" }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <section v-if="selectelement.advanced.socmed || selectelement.advanced.ecommerce || selectelement.advanced.exposed || selectelement.education.education || selectelement.education.career || selectelement.website.web">
                                <div v-if="adv_socmed || adv_ecommerce || adv_exposed[0] || education || career || webinfo" class="html2pdf__page-break"/>
                                <div class="invoice-title pt-4 pb-1 d-flex justify-content-between align-items-center" v-if="adv_socmed || adv_ecommerce || adv_exposed[0] || education || career || webinfo">
                                    <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                      <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                </div>
                                <hr v-if="adv_socmed || adv_ecommerce || adv_exposed[0] || education || career || webinfo" class="mb-4" />
                                <h4 class="text-center mb-4 text-uppercase font-weight-bolder" v-if="adv_socmed || adv_ecommerce || adv_exposed[0] || education || career || webinfo">{{ $t('advanced.advanced-data') }}</h4>
                                <div class="mt-4 d-flex">
                                    <div class="w-100">
                                        <div class="table-responsive pr-2" v-if="selectelement.education.education && education">
                                            <table class="table table-bordered w-100">
                                                <thead>
                                                    <tr>
                                                        <th colspan="2" class="h5 bg-secondary text-white">{{ $t('education.education-info') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                        <tr>
                                                            <td width="25%">
                                                              {{ $t('education.name') }}
                                                            </td>
                                                            <td>
                                                            {{education == null ? '' : education.nm_pd}}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="25%">
                                                                NIM
                                                            </td>
                                                            <td>
                                                            {{education == null ? '' : education.nipd}}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="25%">
                                                                {{ $t('education.perguruan-tinggi') }}
                                                            </td>
                                                            <td>
                                                            {{education == null ? '' : education.namapt}}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="25%">
                                                                {{ $t('education.jenjang') }}
                                                            </td>
                                                            <td>
                                                            {{education == null ? '' : education.namajenjang}}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="25%">
                                                                {{ $t('education.program-studi') }}
                                                            </td>
                                                            <td>
                                                            {{education == null ? '' : education.namaprodi}}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="25%">
                                                                {{ $t('education.jenis-kelamin') }}
                                                            </td>
                                                            <td>
                                                            {{education == null ? '' : education.jk}}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="25%">
                                                                {{ $t('education.semester-awal') }}
                                                            </td>
                                                            <td>
                                                            {{education == null ? '' : education.mulai_smt}}
                                                            </td>
                                                        </tr>
                                                        <tr v-if="education == null ? '' : education.nm_jns_daftar">
                                                            <td width="25%">
                                                                {{ $t('education.status-awal') }}
                                                            </td>
                                                            <td>
                                                            {{education == null ? '' : education.nm_jns_daftar}}
                                                            </td>
                                                        </tr>
                                                        <tr v-if="education == null ? '' : education.nama_pt_asal">
                                                            <td width="25%">
                                                                {{ $t('education.nama-pt-awal') }}
                                                            </td>
                                                            <td>
                                                            {{education == null ? '' : education.nama_pt_asal}}
                                                            </td>
                                                        </tr>
                                                        <tr v-if="education == null ? '' : education.nm_prodi_asal">
                                                            <td width="25%">
                                                                {{ $t('education.prodi-asal') }}
                                                            </td>
                                                            <td>
                                                            {{education == null ? '' : education.nm_prodi_asal}}
                                                            </td>
                                                        </tr>
                                                        <tr v-if="education == null ? '' : education.ket_keluar">
                                                        <td width="25%">
                                                        {{ $t('education.status') }}  
                                                        </td>
                                                        <td>
                                                        {{education == null ? '' : education.ket_keluar}}
                                                        </td>
                                                        </tr>
                                                        <tr v-if="education == null ? '' : education.tgl_keluar">
                                                        <td width="25%">
                                                        {{ $t('education.tanggal-lulus') }} 
                                                        </td>
                                                        <td>
                                                        <span v-if="education == null ? '' : education.tgl_keluar">{{formatDate(education.tgl_keluar)}} </span>
                                                        </td>
                                                        </tr>
                                                        <tr v-if="education == null ? '' : education.no_seri_ijazah">
                                                        <td width="25%">
                                                        {{ $t('education.nomer-ijazah') }} 
                                                        </td>
                                                        <td>
                                                        {{education == null ? '' : education == null ? '' : education.no_seri_ijazah}}
                                                        </td>
                                                        </tr>
                                                        <tr v-if="education == null ? '' : education.sert_prof">
                                                        <td width="25%">
                                                        {{ $t('education.sertifikasi-profesi') }}
                                                        </td>
                                                        <td>
                                                        {{education == null ? '' : education.sert_prof}}
                                                        </td>
                                                    </tr>
                                                
                                                </tbody>
                                            </table>
                                        </div>

                                        <div class="table-responsive pr-2"  v-if="selectelement.education.career && career">
                                            <table class="table table-bordered w-100">
                                                <thead>
                                                    <tr>
                                                        <th colspan="2" class="h5 bg-secondary text-white">{{ $t('education.career-info') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td width="25%">
                                                        <div class="">
                                                                {{$t('education.avatar')}}
                                                        </div>
                                                        </td>
                                                         <td>
                                                            <div class="col-sm-10">
                                                                <img :src="career.profile_picture" alt="" class="img-fluid rounded avatar-md" srcset="">
                                                            </div>
                                                        </td>
                                                    </tr>  
                                                    <tr>
                                                        <td width="25%">
                                                            {{$t('education.profil_id')}}
                                                        </td>
                                                        <td>
                                                        {{career.profile_id}}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="25%">
                                                        {{$t('education.first_name')}}
                                                        </td>
                                                        <td>
                                                            {{career.first_name}} 
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="25%">
                                                            {{$t('education.last_name')}}
                                                        </td>
                                                        <td>
                                                        {{career.last_name}}
                                                        </td>
                                                    </tr>                            
                                                    <tr>
                                                        <td width="25%">
                                                            {{$t('education.position')}}
                                                        </td>
                                                        <td>
                                                        <div v-for="(position, index) in profile_positions" :key="index" class="border mb-2 p-2">
                                                            <span v-if="position.company"><img :src="position.company.logo" alt="" class="img-fluid rounded avatar-xs mb-1" srcset="" v-if="position.company.logo !== null"> <img src="https://static-exp1.licdn.com/sc/h/3dtfvv2esz58o2zimai1h4v2d" alt="" class="img-fluid rounded avatar-xs mb-1" srcset="" v-else><br> </span> 
                                                            <span v-if="position.company"> <b>{{$t('education.company')}} : </b>{{position.company.name}}  <br></span>
                                                            <span v-if="position.profile_positions"><b>{{$t('education.title')}} :</b> {{position.profile_positions[0].title}}  <br> </span>
                                                            <span v-if="position.profile_positions"> <b>{{$t('education.location')}} : </b> {{position.profile_positions[0].location}}  <br></span>
                                                            <div v-if="position.date"><b  v-if="position.date.start">{{$t('education.start')}} : </b> <span v-if="position.date.start">{{position.date.start.year}} -  {{formatMonth(position.date.start.month)}}</span> <br> </div>
                                                            <div v-if="position.date"><b v-if="position.date.end"> {{$t('education.end')}} : </b> <span v-if="position.date.end">{{position.date.end.year}} -  {{formatMonth(position.date.end.month)}} </span><br> </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="skills[0]">
                                                        <td width="25%">
                                                            {{$t('education.skills')}}
                                                        </td>
                                                        <td>
                                                        <span v-for="(sk, index) in skills" :key="index" class="btn btn-sm btn-light mr-1 mb-1 text-secondary">{{sk}} </span>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="certifications.lenght > 0">
                                                        <td width="25%">
                                                            {{$t('education.sertifikat')}}
                                                        </td>
                                                        <td>
                                                        <div v-for="(cer, index) in certifications" :key="index" class="border mb-2 p-2">
                                                            <span v-if="cer.company"><img :src="cer.company.logo" alt="" class="img-fluid rounded avatar-sm mb-1" srcset=""><br> </span> 
                                                            <span v-if="cer.name"><b>{{$t('education.name')}} :</b> {{cer.name}} <br> </span>
                                                            <span v-if="cer.date"><b>{{$t('education.year')}} : </b> {{cer.date.start.year}} -  {{formatMonth(cer.date.start.month)}} <br> </span>
                                                            <span v-if="cer.license_number"> <b>{{$t('education.licensi-number')}} : </b>{{cer.license_number}}  <br></span>
                                                            <span v-if="cer.url"><b>{{$t('education.link')}} : </b> <a :href="cer.url" target="_blank" rel="noopener noreferrer"> {{cer.url}} </a><br></span>
                                                            <span v-if="cer.display_source"><b>{{$t('education.source')}} : </b>{{cer.display_source}}<br> </span>
                                                            <span v-if="cer.authority"> <b>{{$t('education.authority')}} : </b>{{cer.authority}}<br> </span>
                                                        </div>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="publications.length > 0">
                                                        <td width="25%">
                                                        {{$t('education.publications')}} 
                                                        </td>
                                                        <td>
                                                        <div v-for="(publics, index) in publications" :key="index" class="border mb-2 p-2">
                                                                <span><b>{{$t('education.headline')}} : </b> <a :href="publics.url" target="_blank" rel="noopener noreferrer">{{publics.name}}</a></span> <br>
                                                                <span><b> {{$t('education.date')}} : </b><span v-if="publics.date.day">{{publics.date.day}}</span><span v-if="publics.date.month"> {{formatMonth(publics.date.month)}}</span> {{publics.date.year}}</span> <br>
                                                                <span><b> {{$t('education.publiser')}} : </b>{{publics.publisher}}</span> <br>
                                                                <b>  {{$t('education.authors')}} : </b><span v-for="(ath, index) in publics.authors" :key="index">({{ath.first_name}} {{ath.last_name}}, {{ath.headline}}, {{ath.type}}), </span> <br>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-2 d-flex">
                                    <div class="w-100">
                                        <div class="table-responsive pr-2" v-if="selectelement.advanced.socmed && adv_socmed">
                                            <table class="table table-bordered w-100">
                                                <thead>
                                                    <tr>
                                                        <th colspan="2" class="h5 bg-secondary text-white">{{ $t('advanced.social-media-database') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td width="25%"><b>{{$t('advanced.name')}}</b></td>
                                                        <td width="75%">
                                                         {{adv_socmed.first_name + " " + adv_socmed.last_name}} 
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="25%"><b>{{$t('advanced.gender')}}</b></td>
                                                        <td width="75%">{{adv_socmed.gender}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td width="25%"><b>{{$t('advanced.phone')}}</b></td>
                                                        <td width="75%">{{adv_socmed.phone}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td width="25%"><b>{{$t('advanced.hometown')}}</b></td>
                                                        <td width="75%">{{adv_socmed.hometown}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td width="25%"><b>{{$t('advanced.city')}}</b></td>
                                                        <td width="75%">{{adv_socmed.current_city}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td width="25%"><b>{{$t('advanced.work')}}</b></td>
                                                        <td width="75%">{{adv_socmed.work}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td width="25%"><b>Status</b></td>
                                                        <td width="75%">{{adv_socmed.status}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <div class="table-responsive pr-2" v-if="selectelement.advanced.ecommerce && adv_ecommerce">
                                            <table class="table table-bordered w-100">
                                                <thead>
                                                    <tr>
                                                        <th colspan="2" class="h5 bg-secondary text-white">{{ $t('advanced.ecommerce-database') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                        <tr>
                                                        <td width="25%"><b>{{$t('advanced.name')}}</b></td>
                                                        <td width="75%">
                                                            {{adv_ecommerce.full_name}} 
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="25%"><b>{{$t('advanced.gender')}}</b></td>
                                                        <td width="75%">{{adv_ecommerce.sex}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td width="25%"><b>{{$t('advanced.phone')}}</b></td>
                                                        <td width="75%">{{adv_ecommerce.phone}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td width="25%"><b>{{$t('advanced.email')}}</b></td>
                                                        <td width="75%">{{adv_ecommerce.user_email}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td width="25%"><b>{{$t('advanced.hoobies')}}</b></td>
                                                        <td width="75%">{{adv_ecommerce.hobbies}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td width="25%"><b>{{$t('advanced.bithday')}}</b></td>
                                                        <td width="75%">{{adv_ecommerce.birth_date}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td width="25%"><b>Status</b></td>
                                                        <td width="75%">{{adv_ecommerce.status}}</td>
                                                    </tr>
                                                
                                                </tbody>
                                            </table>
                                        </div>

                                        <div class="boorder pr-2" v-if="selectelement.advanced.exposed &&  adv_exposed[0]">
                                           <table class="table table-bordered w-100">
                                                <thead>
                                                    <tr>
                                                        <th colspan="2" class="h5 bg-secondary text-white">{{ $t('advanced.exposed') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <div class="row my-2 mx-1" v-if="adv_exposed[0]">
                                                    <div
                                                        v-for="(e, index) in adv_exposed"
                                                        :key="index"
                                                        class="col-sm-6 py-2"
                                                    >
                                                        <div
                                                        class="
                                                            d-block
                                                            border border-primary
                                                            rounded
                                                            p-2
                                                            h-100
                                                        "
                                                        >
                                                        <div
                                                            class="
                                                            d-flex
                                                            align-items-center
                                                            justify-content-between
                                                            "
                                                        >
                                                            <h5 class="text-truncate">{{ e.source }}</h5>
                                                            <i
                                                            v-if="e.has_password == 0"
                                                            class="bx bxs-lock bx-sm"
                                                            ></i>
                                                            <i
                                                            v-if="e.has_password == 1"
                                                            class="text-success bx bxs-lock-open bx-sm"
                                                            ></i>
                                                        </div>
                                                        <hr />
                                                        <div class="text-xs">
                                                            <small v-if="e.email"
                                                            >Email : {{ e.email }}</small
                                                            ><br />
                                                            <small v-if="e.has_password"
                                                            >Password : {{ e.password }}</small
                                                            ><br />
                                                            <small v-if="e.has_password"
                                                            >Password Hash : {{ e.hash }}</small
                                                            >
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                </tbody>
                                           </table>
                                        </div>
                                    </div>
                                </div>

                                <div class="mt-2 d-flex">
                                    <div class="w-100">
                                        <div class="table-responsive pr-2" v-if="selectelement.website.web && webinfo">
                                            <table class="table table-bordered w-100">
                                                <thead>
                                                    <tr>
                                                        <th colspan="2" class="h5 bg-secondary text-white">{{ $t('website.website-info') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                     <tr>
                                                        <th class="p-2">Domain</th>
                                                        <td class="p-2">{{webinfo.domain_name}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.ip_address') }}</th>
                                                        <td class="p-2">{{webinfo.ip_address}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.visitors') }}</th>
                                                        <td class="p-2">{{webinfo.visitors}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.ip_location') }}</th>
                                                        <td class="p-2">{{webinfo.ip_location}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.ip_reserve_dns') }}</th>
                                                        <td class="p-2">{{webinfo.ip_reverse_dns}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.hosting_company') }}</th>
                                                        <td class="p-2">{{webinfo.hosting_company}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.hosting_ip_range') }}</th>
                                                        <td class="p-2">{{webinfo.hosting_ip_range}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.hosting_address') }}</th>
                                                        <td class="p-2">{{webinfo.hosting_address}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.hosting_country') }}</th>
                                                        <td class="p-2">{{webinfo.hosting_country}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.hosting_phone') }}</th>
                                                        <td class="p-2">{{webinfo.hosting_phone}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">CIDR</th>
                                                        <td class="p-2">{{webinfo.cidr}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.hosting_cidr') }}</th>
                                                        <td class="p-2">{{webinfo.hosting_cidr}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <!-- <div class="table-responsive pr-2">
                                            <table class="table table-bordered w-100">
                                                <thead>
                                                    <tr>
                                                        <th colspan="2" class="h5 bg-secondary text-white">{{ $t('website.geografis-info') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.region') }}</th>
                                                        <td class="p-2">{{iplocation.region}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.country_name') }}</th>
                                                        <td class="p-2">{{iplocation.country_name}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.postal') }}</th>
                                                        <td class="p-2">{{(iplocation.postal_code)}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.latitude') }}</th>
                                                        <td class="p-2">{{iplocation.latitude}},  {{iplocation.longitude}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="p-2">{{ $t('website.timezone') }}</th>
                                                        <td class="p-2">{{iplocation.timezone}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div> -->
                                    </div>
                                </div>
                            </section>
                            
                            <div v-if="selectelement.news.list.length > 0">
                                <div class="html2pdf__page-break"/>
                                    <div class="invoice-title px-0 pt-4 pb-1 d-flex justify-content-between align-items-center">
                                        <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                          <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                    </div>
                                <hr class="mb-4" />
                                <h4 class="text-center mb-4 text-uppercase font-weight-bolder">{{ $t('news.related-news') }}</h4>
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <tbody>
                                            <tr v-for="(nw, index) in selectelement.news.list" :key="index">
                                                <td>
                                                    <div class="row">
                                                        <div class="col-3">
                                                            <img :src="nw.image" alt="" width="100%" class="img-fluid rounded">
                                                        </div>
                                                        <div class="col-9">
                                                            <span><b>{{ $t('news.title') }} :</b> {{nw.title}} <br></span>
                                                            <span><b>{{ $t('news.published_at') }} :</b><span class="text-secondary"> {{nw.source}} - {{formatDate(nw.published_at)}}</span><br></span>
                                                            <span><b>Url : </b> <a :href="nw.url" target="_blank" rel="noopener noreferrer"> {{nw.url}}</a></span>
                                                        </div> 
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="html2pdf__page-break"/>
                                    <div class="invoice-title px-0 pt-4 pb-1 d-flex justify-content-between align-items-center">
                                        <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                          <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                    </div>
                                <hr class="mb-4" />
                                <h4 class="text-center mb-4 text-uppercase font-weight-bolder">{{ $t('report.news-analystic') }}</h4>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="clearfix">
                                                <h5 class="card-title mb-4"> {{ $t('news.source') }}</h5>
                                                <hr>
                                        </div>
                                        <div v-if="!loadingNews.source">
                                            <div v-if="!nodata.source">
                                                <apexchart
                                                ref="source"
                                                class="apex-charts"
                                                height="400"
                                                type="donut"
                                                dir="ltr"
                                                :series="seriesSource"
                                                :options="{
                                                        plotOptions: {
                                                            pie: {
                                                                    donut: {
                                                                    labels: {
                                                                        show: true,
                                                                        name: {
                                                                            show: true,
                                                                            fontSize: '22px',
                                                                            fontFamily: 'Rubik',
                                                                            color: theme == 'dark'? '#F8F8FB' : '#343a40',
                                                                        },
                                                                        value: {
                                                                            show: true,
                                                                            fontSize: '16px',
                                                                            fontFamily: 'Helvetica, Arial, sans-serif',
                                                                            color: theme == 'dark'? '#F8F8FB' : '#343a40',
                                                                        },
                                                                        total: {
                                                                            show: true,
                                                                            label: 'Total',
                                                                            color: theme == 'dark'? '#F8F8FB' : '#343a40'
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                        },
                                                        labels: labelsSource,
                                                        colors: colorsSource,
                                                        legend: {
                                                            show: true,
                                                            position: 'bottom',
                                                            horizontalAlign: 'center',
                                                            verticalAlign: 'middle',
                                                            floating: false,
                                                            fontSize: '14px',
                                                            offsetX: 0,
                                                            offsetY: -10,
                                                            labels: {
                                                                colors: theme == 'dark'? '#F8F8FB' : '#343a40',
                                                            }
                                                        },
                                                        responsive: [{
                                                            breakpoint: 600,
                                                            options: {
                                                                chart: {
                                                                    height: 240
                                                                },
                                                                legend: {
                                                                    show: false
                                                                },
                                                            }
                                                        }]
                                                    }"
                                                />
                                            </div>
                                            <div class="d-flex flex-column justify-content-center align-items-center" style="margin-top:15%;margin-bottom:15%;" v-else>
                                                <i class="bx bxs-doughnut-chart bx-lg"></i>
                                                <span> {{ $t('all.dnf') }}</span>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column justify-content-center align-items-center" style="margin-top:15%;margin-bottom:15%;" v-else>
                                            <i class="bx bx-loader-alt bx-lg bx-spin"></i>
                                        </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="clearfix">
                                                <h5 class="card-title mb-4"> {{ $t('news.sentiment') }}</h5>
                                                <hr>
                                            </div>
                                            <div v-if="!loadingNews.allsentiment">
                                                <div v-if="!nodata.allsentiment">
                                                    <apexchart
                                                        ref="senti"
                                                        class="apex-charts"
                                                        height="400"
                                                        type="pie"
                                                        dir="ltr"
                                                        :series="seriesSentiment"
                                                        :options="{
                                                            labels: labelsSentiment,
                                                            colors: colorsSentiment,
                                                            legend: {
                                                                show: true,
                                                                position: 'bottom',
                                                                horizontalAlign: 'center',
                                                                verticalAlign: 'middle',
                                                                floating: false,
                                                                fontSize: '14px',
                                                                offsetX: 0,
                                                                offsetY: -10,
                                                                labels: {
                                                                    colors: theme == 'dark'? '#F8F8FB' : '#343a40',
                                                                }
                                                            },
                                                            responsive: [{
                                                                breakpoint: 600,
                                                                options: {
                                                                    chart: {
                                                                        height: 500
                                                                    },
                                                                    legend: {
                                                                        show: false
                                                                    },
                                                                }
                                                            }]
                                                        }"
                                                    />
                                                </div>
                                                <div class="d-flex flex-column justify-content-center align-items-center" style="margin-top:15%;margin-bottom:15%;" v-else>
                                                    <i class="bx bxs-pie-chart-alt-2 bx-lg"></i>
                                                    <span>{{ $t('all.dnf') }}</span>
                                                </div>
                                            </div>
                                            <div class="d-flex flex-column justify-content-center align-items-center" style="margin-top:15%;margin-bottom:15%;" v-else>
                                                <i class="bx bx-loader-alt bx-lg bx-spin"></i>
                                            </div>
                                        </div>
                                </div>
                            </div>

                            <section v-if="selectelement.sna">
                                <div class="html2pdf__page-break"/>
                                    <div class="invoice-title px-0 pt-4 pb-1 d-flex justify-content-between align-items-center">
                                        <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                          <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                    </div>
                                    <hr class="mb-4" />
                                    <!-- <h4 class="text-center mb-4 text-uppercase font-weight-bolder">{{ $t('report.social-network-analys') }}</h4> -->
                                    <h4 class="text-center mb-4 text-uppercase font-weight-bolder">Canvas</h4>
                                    <cytoscape
                                        v-if="dataRelationSNA"
                                        class="mt-4"
                                        ref="cyRef"
                                        :afterCreated="afterCreatedSNA"
                                        :preConfig="preConfigSNA"
                                        :config="configSNA">
                                    </cytoscape>
                                    <div>
                                    <div class="row p-2">
                                        <div class="col-4 p-1" v-if="degrees">
                                            <p class="h5">Degree</p>
                                            <table class="table table-bordered mb-0" >
                                                <thead>
                                                    <tr>
                                                        <th width="80%">Node</th>
                                                        <th>{{ $t('overview.score') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(value, key, index) in degrees" :key="key" :class="index == 0 ? 'bg-primary text-white':''">
                                                        <td>{{key}}</td>
                                                        <td>{{value.toFixed(2) }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="col-4 p-1" v-if="betweeness">
                                            <p class="h5"> Betweeness</p>
                                            <table class="table table-bordered mb-0">
                                                <thead>
                                                    <tr>
                                                        <th width="80%">Node</th>
                                                        <th>{{ $t('overview.score') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(value, key, index) in betweeness" :key="key" :class="index == 0 ? 'bg-warning text-white':''">
                                                        <td>{{key}}</td>
                                                        <td>{{value.toFixed(2) }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="col-4 p-1 " v-if="closeness">
                                            <p class="h5">Closeness</p>
                                            <table class="table table-bordered mb-0">
                                                <thead>
                                                    <tr>
                                                        <th width="80%">Node</th>
                                                        <th>{{ $t('overview.score') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(value, key, index) in closeness" :key="key" :class="index == 0 ? 'bg-success text-white':''">
                                                        <td>{{key}}</td>
                                                        <td>{{value.toFixed(2) }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </simplebar>
                </div>
            </div>
        </div>
        <!-- VIEW TO PRINT & EXPORT PDF -->
        <div class="row">
            <div class="col-12">
                <simplebar style="max-height: 70vh;">
                    <vue-html2pdf
                        :show-layout="false"
                        :float-layout="true"
                        :enable-download="enableDownload"
                        :preview-modal="previewModal"
                        :paginate-elements-by-height="1400"
                        :filename="filename"
                        :pdf-quality="2"
                        :manual-pagination="true"
                        pdf-format="a4"
                        pdf-orientation="portrait"
                        pdf-content-width="800px"
                        ref="html2Pdf"
                    >
                        <section slot="pdf-content">
                            <img ref="img1" src="">
                            <div class="card">
                                <div class="card-body">
                                    <div class="invoice-title d-flex justify-content-between align-items-center">
                                        <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                          <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                    </div>
                                    <hr class="mb-4" />
                                    <h4 class="text-center mb-4 text-uppercase font-weight-bolder">{{ $t('report.target-profile') }}</h4>
                                <div class="row mt-4">
                                    <div class="col-2 d-flex p-2">
                                        <img :src="urlimage+target.image_project" class="avatar-xl rounded-circle mr-4 " role="button"/>
                                    </div>
                                    <div class="col-7 ">
                                        <h4 class="mt-3 border-bottom border-primary">{{target.title}}</h4>
                                        <span><strong>{{ $t('report.category') }} </strong> <br> {{target.category == null ? '' : target.category.category_name}}</span>
                                        <div class="d-flex flex-column mt-1">
                                        <strong>{{ $t('report.description') }} </strong>
                                            <p class="text-justify">{{target.description}}</p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <apexchart class="apex-charts" type="radialBar" height="180" :options="gaugeOptions" :series="gaugeSeries"></apexchart>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 mt-2">
                                        <strong>{{ $t('report.description-other') }}</strong>
                                        <p class="text-justify pr-2" v-html="target.other_description"></p>
                                    </div>
                                    <div class="col-12 mt-3">
                                        <div class="d-flex flex-column mt-1">
                                            <strong>{{ $t('report.relation-profile') }}</strong>
                                            <div class="team-member d-flex mt-1">
                                                <div class="container-fluid">
                                                    <div class="row ">
                                                        <div class="col-2 mb-3 p-2 text-center border" v-for="(relation, index) in JSON.parse('['+target.relation_profile+']')" :key="index">
                                                            <span class="d-flex">
                                                                <img :title="relation.name" :src="urlimage+relation.image"  class="rounded-circle avatar-xs mx-auto" alt />
                                                            </span>
                                                            <span>{{relation.name}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>       
                                </div>
                            
                                <!-- private data -->
                                <section v-if="selectelement.citizen && selectelement.phone">
                                    <div v-if="private_data || citizen" class="html2pdf__page-break"/>
                                        <div class="invoice-title pt-4 pb-1 d-flex justify-content-between align-items-center" v-if="private_data || citizen">
                                            <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                              <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                        </div>
                                    <hr v-if="private_data || citizen" class="mb-4" />
                                    <h4 class="text-center mb-4 text-uppercase font-weight-bolder" v-if="private_data || citizen">{{ $t('report.private-data') }}</h4>
                                    <div class="table-responsive" v-if="selectelement.citizen">
                                        <table class="table table-bordered">
                                            <thead>
                                            <tr>
                                                <th style="width: 70px;" colspan="3" class="text-left h5 bg-secondary text-white">{{ $t('report.citizen-profile') }}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <th width="25%">NIK</th>
                                                <td colspan="2">
                                                    {{citizen == null ? '-' : citizen.nik }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t("overview.table.citizen.name") }}</th>
                                                <td colspan="2">
                                                    {{citizen == null ? '-' : citizen.name}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t("overview.table.citizen.birth-place") }}, {{ $t("overview.table.citizen.date-of-birth") }}</th>
                                                <td colspan="2">{{citizen == null ? '-' : citizen.birth_place}}, {{citizen == null ? '-' : citizen.date_of_birth}}</td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t("overview.table.citizen.gender") }}</th>
                                                <td colspan="2">{{citizen == null ? '-' : citizen.gender == 'L' ? 'Laki-laki' : 'Perempuan'}}</td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t("overview.table.citizen.religion") }}</th>
                                                <td colspan="2">{{citizen == null ? '-' : citizen.religion}}</td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t("overview.table.citizen.profession") }}</th>
                                                <td colspan="2">{{citizen == null ? '-' : citizen.profession == 0 ? 'Belum Bekerja' : '-'}}</td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t("overview.table.citizen.nationality") }}</th>
                                                <td colspan="2" class="text-capitalize">{{citizen == null ? '-' : citizen.nationality}}</td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t("overview.table.citizen.address") }}</th>
                                                <td colspan="2">{{citizen == null ? '-' : citizen.address}}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="table-responsive" v-if="selectelement.phone && private_data">
                                        <table class="table table-bordered">
                                            <thead>
                                            <tr>
                                                <th style="width: 70px;" colspan="3" class="text-left h5 bg-secondary text-white">{{ $t('report.phone') }}/Email</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <th width="25%">Email</th>
                                                <td colspan="2">
                                                    {{private_data ? private_data.email : "-"}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t('phone.phone-number') }}</th>
                                                <td colspan="2">{{private_data ? private_data.phone : "-"}}</td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t('phone.country-code') }}</th>
                                                <td colspan="2">{{private_data ? private_data.phone_country_code : "-"}}</td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t('phone.carrier') }}</th>
                                                <td colspan="2">{{private_data ? private_data.phone_carrier : "-"}}, {{private_data ? private_data.phone_location : "-"}}</td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t('phone.timezone') }}</th>
                                                <td colspan="2">{{private_data ? private_data.phone_timezone : "-"}}</td>
                                            </tr>
                                            <tr v-if="selectelement.tag && tags != 0">
                                                <th>{{ $t('report.tag') }}</th>
                                                <td colspan="2">
                                                    <div class="row">
                                                        <div class="col-sm-3 my-auto pb-2" v-for="(tg, index) in JSON.parse(tags)" :key="index">
                                                                <b-button variant="outline-secondary btn-block" size="xs" class="btn-sm">{{tg}}</b-button>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </section>

                                <div v-if="selectelement.image.show && selectelement.image.list[0]">
                                    <div class="html2pdf__page-break"/>
                                    <div class="invoice-title pt-4 pb-1 d-flex justify-content-between align-items-center">
                                        <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                          <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                    </div>
                                    <hr class="mb-4" />
                                    <h4 class="text-center mb-4 text-uppercase font-weight-bolder">{{ $t('report.relation-image') }}</h4>
                                    <div class="table-responsive">
                                        <table class="table table-bordered border">
                                            <thead>
                                                <tr>
                                                    <th style="width: 70px;" class="text-center">{{ $t('report.image') }}</th>
                                                    <th style="width: 70px;" colspan="2" class="text-center">{{ $t('report.image-noted') }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(im, index) in selectelement.image.list" :key="index">
                                                    <td width="30%" class="text-center">
                                                        <img v-if="im.source == 'twitter'" :src="im.image_name == null ? im.path : getImage(im.image_name, im.path)" style="height:180px; width:auto;" class="img-fluid border border-1 border-dark rounded" alt="Responsive image">
                                                        <img v-if="im.source == 'instagram_img' || im.source == 'manual'" :src="getImage(im.image_name, im.path)" style="height:180px; width:auto;" class="img-fluid border border-1 border-dark rounded " alt="Responsive image">
                                                    </td>
                                                    <td colspan="2">
                                                        <tr >
                                                            <td style="border:none;padding:5px;">{{ $t('report.source') }}</td>
                                                            <td style="border:none;padding:5px;">:</td>
                                                            <td v-if="im.source == 'instagram_img'" style="border:none;padding:5px;">Instagram</td>
                                                            <td v-else-if="im.source == 'twitter'" style="border:none;padding:5px;">Twitter</td>
                                                            <td v-else style="border:none;padding:5px;">{{ $t('report.image-manual-add') }}</td>
                                                        </tr>
                                                        <tr style="border:none;padding:5px;">
                                                            <td style="border:none;padding:5px;">{{ $t('report.image-noted') }}</td>
                                                            <td style="border:none;padding:5px;">:</td>
                                                            <td style="border:none;padding:5px;">
                                                                {{im.notes}}
                                                            </td>
                                                        </tr>
                                                        <tr style="border:none;padding:5px;">
                                                            <td style="border:none;padding:5px;">{{ $t('report.image-analytic-noted') }} </td>
                                                            <td style="border:none;padding:5px;">:</td>
                                                            <td style="border:none;padding:5px;">
                                                                {{im.analytic_notes}}
                                                            </td>
                                                        </tr>
                                                        <div class="html2pdf__page-break" v-if="index == 3 || index == 7 || index == 11"/>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <!-- social media -->
                                <section v-if="selectelement.sosmed.twitter || selectelement.sosmed.instagram || selectelement.sosmed.telegram">
                                    <div v-if="twitter || instagram || telegram" class="html2pdf__page-break"/>
                                        <div class="invoice-title pt-4 pb-1 d-flex justify-content-between align-items-center" v-if="twitter || instagram || telegram">
                                            <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                              <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                        </div>
                                    <hr v-if="twitter || instagram || telegram" class="mb-4" />
                                    <h4 class="text-center mb-4 text-uppercase font-weight-bolder" v-if="twitter || instagram || telegram">{{ $t('report.social-media') }}</h4>
                                    <div class="table-responsive" v-if="selectelement.sosmed.twitter">
                                        <table class="table table-bordered">
                                            <thead>
                                            <tr>
                                                <th style="width: 70px;" colspan="3" class="h5 bg-secondary text-white">Twitter </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <th width="25%">Avatar</th>
                                                <td colspan="2">
                                                    <div>
                                                        <img
                                                            :src="twitter.avatar"
                                                            class="mr-3 rounded-circle avatar-sm"
                                                            alt="user-pic"
                                                            />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th width="25%">Username</th>
                                                <td colspan="2">
                                                    {{twitter == null ? '-' : twitter.account }}  <span v-if="twitter.verified == true"><i class="my-auto ml-1 text-primary mdi mdi-check-decagram mdi-18px"></i></span>

                                                </td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t("twitter.table.name") }}</th>
                                                <td colspan="2">
                                                    {{twitter == null ? '-' : twitter.name}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t("twitter.table.followers") }}</th>
                                                <td colspan="2">{{twitter == null ? '-' : twitter.followers}}</td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t("twitter.table.following") }}</th>
                                                <td colspan="2">{{twitter == null ? '-' : twitter.following}}</td>
                                            </tr>
                                            <tr>
                                                <th>Bio</th>
                                                <td colspan="2">{{twitter == null ? '-' : twitter.bio}}</td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t("twitter.table.post") }}</th>
                                                <td colspan="2">{{twitter == null ? '-' : twitter.tweets}}</td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t("twitter.table.joint-at") }}</th>
                                                <td colspan="2">{{twitter == null ? '-' : formatDate(twitter.join_at)}}</td>
                                            </tr>
                                            <tr>
                                                <th> {{ $t("twitter.update") }} </th>
                                                <td colspan="2">{{twitter == null ? '-' : formatDate(twitter.updated_at)}}</td>
                                            </tr>
                                        
                                            </tbody>
                                        </table>
                                    </div>

                                    <div class="table-responsive" v-if="selectelement.sosmed.instagram">
                                        <div class="html2pdf__page-break"/>
                                        <table class="table table-bordered mt-3">
                                            <thead>
                                            <tr>
                                                <th style="width: 70px;" colspan="3" class="h5 bg-secondary text-white">Instagram</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <th width="25%">Avatar</th>
                                                <td colspan="2">
                                                    <div>
                                                        <img
                                                            :src="avatar_ig+instagram.picture"
                                                            class="mr-3 rounded-circle avatar-sm"
                                                            alt="user-pic"
                                                            v-if="instagram.picture_hd"
                                                        />
                                                        <img :src="instagram.picture" alt="img" class="mr-3 rounded-circle avatar-sm" v-if="instagram.picture && !instagram.picture_hd">
                                                        <img
                                                            :src="theme == 'dark' ? 'https://img.icons8.com/ios/240/FFFFFF/user-male-circle.png' : 'https://img.icons8.com/ios/240/000000/user-male-circle.png'"
                                                            class="mr-3 rounded-circle avatar-sm"
                                                            alt="user-pic" v-if="!instagram.picture && !instagram.picture_hd"
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th width="25%">Username</th>
                                                <td colspan="2">
                                                    {{instagram == null ? '-' : instagram.account }} 
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t("twitter.table.name") }}</th>
                                                <td colspan="2">
                                                    {{instagram == null ? '-' : instagram.full_name}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Bio</th>
                                                <td colspan="2">{{instagram == null ? '-' : instagram.bio}}</td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t("instagram.followers") }}</th>
                                                <td colspan="2">{{instagram == null ? '-' : instagram.followers}}</td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t("instagram.following") }}</th>
                                                <td colspan="2">{{instagram == null ? '-' : instagram.following}}</td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t("instagram.post") }}</th>
                                                <td colspan="2">{{instagram == null ? '-' : instagram.media}}</td>
                                            </tr>
                                            <tr>
                                                <th>Category</th>
                                                <td colspan="2">{{instagram == null ? '-' : instagram.category_name}}</td>
                                            </tr>
                                            <tr>
                                                <th> {{ $t("instagram.update") }} </th>
                                                <td colspan="2">{{instagram == null ? '-' : formatDate(instagram.updated_at)}}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div class="table-responsive" v-if="selectelement.sosmed.telegram">
                                        <table class="table table-bordered">
                                            <thead>
                                            <tr>
                                                <th style="width: 70px;" colspan="3" class="h5 bg-secondary text-white">Telegram</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <th width="25%">Username</th>
                                                <td colspan="2">
                                                    {{telegram.account == null ? '-' : telegram.account }} 
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t("overview.table.all.first_name") }}</th>
                                                <td colspan="2">
                                                    {{telegram.first_name == null ? '-' : telegram.first_name}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t("overview.table.all.last_name") }}</th>
                                                <td colspan="2">{{telegram.last_name == null ? '-' : telegram.last_name}}</td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t("overview.table.all.phone") }}</th>
                                                <td colspan="2">{{telegram.phone == null ? '-' : telegram.phone}}</td>
                                            </tr>
                                            <tr>
                                                <th> {{ $t("instagram.update") }} </th>
                                                <td colspan="2">{{telegram.updated_at == null ? '-' : formatDate(telegram.updated_at)}}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </section>

                                <div v-if="selectelement.timeline.show">
                                    <div class="html2pdf__page-break"/>
                                    <div class="invoice-title pt-4 pb-1 d-flex justify-content-between align-items-center">
                                        <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                          <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                    </div>
                                    <hr class="mb-4" />
                                    <h4 class="text-center mb-4 text-uppercase font-weight-bolder">{{ $t('report.social-media') }}</h4>
                                    <div class="">
                                        <p>{{ $t('report.other-medsos')}}</p>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <ol class="list-group-numbered">
                                                    <li class="h5 font-weight-bold">Twitter</li>
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <tr>
                                                                <td width="20%">{{ $t('twitter.table.account') }}</td>
                                                                <td>{{twitter.account}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td width="20%">{{ $t('twitter.table.name') }}</td>
                                                                <td>{{twitter.name}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td width="20%">{{ $t('twitter.table.followers') }}</td>
                                                                <td>{{twitter.followers}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td width="20%">{{ $t('twitter.table.following') }}</td>
                                                                <td>{{twitter.following}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td width="20%">{{ $t('twitter.table.join-at') }}</td>
                                                                <td>{{twitter.join_at}}</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                    <li class="h5 font-weight-bold">Instagram</li>
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <tr>
                                                                <td width="20%">{{ $t('instagram.account') }}</td>
                                                                <td>{{instagram.account}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td width="20%">{{ $t('instagram.full_name') }}</td>
                                                                <td>{{instagram.full_name}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td width="20%">Bio</td>
                                                                <td>{{instagram.bio}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td width="20%">{{ $t('instagram.followers') }}</td>
                                                                <td>{{instagram.followers}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td width="20%">{{ $t('instagram.following') }}</td>
                                                                <td>{{instagram.following}}</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                    <div v-if="private_web != 0 && private_web">
                                                        <li class="h5 font-weight-bold">Website</li>
                                                        <div class="table-responsive">
                                                            <table class="table table-bordered">
                                                                <tr>
                                                                    <td width="20%">{{ $t('website.domain_name') }}</td>
                                                                    <td>{{private_web.domain}}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td width="20%">{{ $t('website.ip') }}</td>
                                                                    <td>{{private_web.ip_address}} </td>
                                                                </tr>
                                                                <tr>
                                                                    <td width="20%">{{ $t('website.ip_location') }}</td>
                                                                    <td>{{private_web.hosting_country}} ({{private_web.ip_location}})</td>
                                                                </tr>
                                                                <tr>
                                                                    <td width="20%">{{ $t('website.hosting_company') }}</td>
                                                                    <td>{{private_web.hosting_company}} </td>
                                                                </tr>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </ol>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="selectelement.timeline.list.length > 0">
                                        <div class="html2pdf__page-break"/>
                                        <div class="invoice-title px-0 pt-4 pb-1 d-flex justify-content-between align-items-center">
                                            <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                              <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                        </div>
                                        <hr class="mb-4" />
                                        <div class="">
                                            <table class="table table-bordered">
                                                <thead>
                                                <tr>
                                                    <th style="border-top: none;" colspan="2" class="h5">{{ $t('report.timeline-list') }}</th>
                                                </tr>
                                                <tr>
                                                    <th width="15%" class="text-center">{{ $t('report.media') }}</th>
                                                    <th width="85%" class="text-center">{{ $t('report.post') }}</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(tm, index) in selectelement.timeline.list" :key="index">
                                                        <td class="px-4 text-center align-middle" width="20%">
                                                            <span class="font-weight-bold text-capitalize">{{tm.type}}</span>
                                                        </td>
                                                        <td >
                                                            <tr>
                                                                <td style="border:none; padding:5px;">{{ $t('report.content') }}</td>
                                                                <td style="border:none;padding:5px;">:</td>
                                                                <td style="border:none;padding:5px;word-break:break-word;white-space: pre-line;overflow-wrap: break-word;-ms-word-break: break-word;word-break: break-word;" class="text-justify">{{tm.caption}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border:none;padding:5px;">{{ $t('report.created-at') }}</td>
                                                                <td style="border:none;padding:5px;">:</td>
                                                                <td style="border:none;padding:5px;">
                                                                    {{formatDate(tm.date)}}
                                                                </td>
                                                            </tr>
                                                            <tr style="border:none;">
                                                                <td style="border:none;padding:5px;">{{ $t('report.link') }}</td>
                                                                <td style="border:none;padding:5px;">:</td>
                                                                <td style="border:none;padding:5px; word-break:break-word;white-space: pre-line;overflow-wrap: break-word;-ms-word-break: break-word;word-break: break-word;">
                                                                    {{tm.link}}
                                                                </td>
                                                            </tr>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <section v-if="selectelement.graph">
                                    <div class="html2pdf__page-break"/>
                                    <div class="invoice-title pt-4 pb-1 d-flex justify-content-between align-items-center">
                                        <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                          <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                    </div>
                                    <hr class="mb-4" />
                                    <h4 class="text-center mb-4 text-uppercase font-weight-bolder">{{ $t('report.relation-graph')}}</h4>
                                    <div class="mt-4">
                                        <cytoscape
                                            v-if="dataRelation && dataWordCloud && dataFollow && dataMention"
                                            ref="cyRef"
                                            :afterCreated="afterCreated"
                                            :preConfig="preConfig"
                                            :config="config">
                                        </cytoscape>
                                    </div>
                                </section>
                                <!-- 
                                <section v-if="selectelement.website.web && webinfo">
                                    <div class="html2pdf__page-break"/>
                                    <div class="invoice-title pt-4 pb-1 d-flex justify-content-between align-items-center">
                                        <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                          <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                    </div>
                                    <hr class="mb-4" />
                                    <h4 class="text-center mb-4 text-uppercase font-weight-bolder">{{ $t('website.website-info') }}</h4>
                                    <p class="h4">Website :  {{webinfo.domain_name}}</p>
                                    <div class="mt-4 d-flex">
                                        <div class="w-100">
                                            <div class="table-responsive pr-2">
                                                <table class="table table-bordered w-100">
                                                    <thead>
                                                        <tr>
                                                            <th colspan="2" class="h5 bg-secondary text-white">{{ $t('website.basic-info') }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.ip_address') }}</th>
                                                            <td class="p-2">{{webinfo.ip_address}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.visitors') }}</th>
                                                            <td class="p-2">{{webinfo.visitors}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.ip_location') }}</th>
                                                            <td class="p-2">{{webinfo.ip_location}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.ip_reserve_dns') }}</th>
                                                            <td class="p-2">{{webinfo.ip_reverse_dns}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.hosting_company') }}</th>
                                                            <td class="p-2">{{webinfo.hosting_company}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.hosting_ip_range') }}</th>
                                                            <td class="p-2">{{webinfo.hosting_ip_range}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.hosting_address') }}</th>
                                                            <td class="p-2">{{webinfo.hosting_address}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.hosting_country') }}</th>
                                                            <td class="p-2">{{webinfo.hosting_country}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.hosting_phone') }}</th>
                                                            <td class="p-2">{{webinfo.hosting_phone}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">CIDR</th>
                                                            <td class="p-2">{{webinfo.cidr}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.hosting_cidr') }}</th>
                                                            <td class="p-2">{{webinfo.hosting_cidr}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div class="table-responsive pr-2">
                                                <table class="table table-bordered w-100">
                                                    <thead>
                                                        <tr>
                                                            <th colspan="2" class="h5 bg-secondary text-white">{{ $t('website.geografis-info') }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.region') }}</th>
                                                            <td class="p-2">{{iplocation.region}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.country_name') }}</th>
                                                            <td class="p-2">{{iplocation.country_name}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.postal') }}</th>
                                                            <td class="p-2">{{(iplocation.postal_code)}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.latitude') }}</th>
                                                            <td class="p-2">{{iplocation.latitude}},  {{iplocation.longitude}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.timezone') }}</th>
                                                            <td class="p-2">{{iplocation.timezone}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="w-100">
                                            <div class="table-responsive pl-2">
                                                <table class="table table-bordered w-100">
                                                    <thead>
                                                        <tr>
                                                            <th colspan="2" class="h5 bg-secondary text-white">{{ $t('website.ip') }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>  
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.ip') }}</th>
                                                            <td class="p-2">{{iplocation.ip_address}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.domain_name') }}</th>
                                                            <td class="p-2">{{iplocation.domain_name}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.version') }}</th>
                                                            <td class="p-2">{{iplocation.version}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.city') }}</th>
                                                            <td class="p-2">{{iplocation.city}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.region') }}</th>
                                                            <td class="p-2">{{iplocation.region}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.region_code') }}</th>
                                                            <td class="p-2">{{iplocation.region_code}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.country_name') }}</th>
                                                            <td class="p-2">{{iplocation.country_name}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.country_code') }}</th>
                                                            <td class="p-2">{{iplocation.country_code}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.country_code_iso3') }}</th>
                                                            <td class="p-2">{{iplocation.country_code_iso3}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.country_tld') }}</th>
                                                            <td class="p-2">{{iplocation.country_tld}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.continent_code') }}</th>
                                                            <td class="p-2">{{iplocation.continent_code}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.continent_code') }}</th>
                                                            <td class="p-2">{{iplocation.continent_code}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.currency') }}</th>
                                                            <td class="p-2">{{iplocation.currency}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.currency_name') }}</th>
                                                            <td class="p-2">{{iplocation.currency_name}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.languages') }}</th>
                                                            <td class="p-2">{{iplocation.languages}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.country_area') }}</th>
                                                            <td class="p-2">{{iplocation.country_area}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">ASN</th>
                                                            <td class="p-2">{{iplocation.asn}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">ORG</th>
                                                            <td class="p-2">{{iplocation.org}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </section> -->

                                <section v-if="selectelement.website.cms && selectelement.website.web && cms">
                                    <div class="html2pdf__page-break"/>
                                    <div class="invoice-title pt-4 pb-1 d-flex justify-content-between align-items-center">
                                        <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                          <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                    </div>
                                    <hr class="mb-4" />
                                    <div class="mt-4 d-flex">
                                        <div class="w-100">
                                            <div class="table-responsive pr-2">
                                                <table class="table table-bordered w-100">
                                                    <thead>
                                                        <tr>
                                                            <th colspan="2" class="h5 bg-secondary text-white">{{ $t('website.cms-info') }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th class="h5 p-2" colspan="2">CMS</th>
                                                        </tr>
                                                        <tr v-for="(data, index) in JSON.parse(cms.result)" :key="index">
                                                            <td class="p-2">{{data.name}}</td>
                                                            <td class="p-2">{{data.categories[0]}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="h5 p-2" colspan="2">{{ $t('website.social-media') }}</th>
                                                        </tr>
                                                        <tr v-for="(data, index) in JSON.parse(cms.social_media)" :key="index">
                                                            <td class="text-capitalize p-2">{{data.network}}</td>
                                                            <td class="p-2">{{data.profile}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <!-- <table class="table table-bordered w-100">
                                                    <thead>
                                                        <tr>
                                                            <th colspan="2" class="h4 bg-secondary text-white">Open Web Service</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(s,index) in service" :key="index">
                                                            <th>{{service[index]}}</th>
                                                            <td>{{s[1]}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table> -->
                                            </div>
                                        </div>
                                        <div class="w-100">
                                            <div class="table-responsive pl-2">
                                                <table class="table table-bordered w-100">
                                                    <thead>
                                                        <tr>
                                                            <th colspan="2" class="h4 bg-secondary text-white">Sub Domain {{ $t('website.sub-domain') }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(data, index) in JSON.parse(subdomain)" :key="index">
                                                            <td class="p-2">{{data.subdomain}}</td>
                                                            <td class="p-2">{{data.ip}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <section v-if="selectelement.website.whois && whois">
                                    <div class="html2pdf__page-break"/>
                                    <div class="invoice-title pt-4 pb-1 d-flex justify-content-between align-items-center">
                                        <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                          <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                    </div>
                                    <hr class="mb-4" />
                                    <h4 class="text-center mb-4 text-uppercase font-weight-bolder">{{ $t('website.whois-info') }}</h4>
                                    <table>
                                        <tr>
                                            <td>{{ $t('website.domain_name') }} </td>
                                            <td class="px-2">:</td>
                                            <td>{{whois != 0 ? whois.domain_name : "-" }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('website.created_date') }} </td>
                                            <td class="px-2">:</td>
                                            <td>{{whois != 0 ? whois.created_date : "-" }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('website.expired_date') }} </td>
                                            <td class="px-2">:</td>
                                            <td>{{whois != 0 ? whois.expired_date : "-" }}</td>
                                        </tr>
                                        <tr>
                                            <td>Email </td>
                                            <td class="px-2">:</td>
                                            <td>{{whois != 0 ? whois.contact_email : "-" }}</td>
                                        </tr>
                                    </table>
                                    <div class="mt-4 d-flex">
                                        <div class="w-100">
                                            <div class="table-responsive pr-2">
                                                <table class="table table-bordered w-100">
                                                    <tbody>
                                                        <tr>
                                                            <th colspan="2" class="h5 bg-secondary text-white">{{ $t('website.registran') }}</th>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.registran_name') }}</th>
                                                            <td class="p-2">{{whois != 0 ? whois.registran_name : "-" }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{$t('website.registrant_organization')}}</th>
                                                            <td class="p-2">{{whois != 0 ? whois.registran_organization : "-" }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{$t('website.registran_street')}}</th>
                                                            <td class="p-2">{{whois != 0 ? whois.registran_street : "-" }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{$t('website.registran_city')}}</th>
                                                            <td class="p-2">{{whois != 0 ? whois.registran_city : "-" }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{$t('website.registran_country')}}</th>
                                                            <td class="p-2">{{whois != 0 ? whois.registran_country : "-" }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{$t('website.registran_country_code')}}</th>
                                                            <td class="p-2">{{whois != 0 ? whois.registrant_countryCode : "-" }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{$t('website.registran_phone')}}</th>
                                                            <td class="p-2">{{whois != 0 ? whois.registran_phone : "-" }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{$t('website.registran_fax')}}</th>
                                                            <td class="p-2">{{whois != 0 ? whois.registran_fax : "-" }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="w-100">
                                            <div class="table-responsive pl-2">
                                                <table class="table table-bordered w-100">
                                                    <tbody>
                                                        <tr>
                                                            <th colspan="2" class="h4 bg-secondary text-white">Admin</th>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{$t('website.admin_name')}}</th>
                                                            <td class="p-2">{{whois != 0 ? whois.admin_name : "-" }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{$t('website.admin_organization')}}</th>
                                                            <td class="p-2">{{whois != 0 ? whois.admin_organization : "-" }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{$t('website.registran_phone')}}</th>
                                                            <td class="p-2">{{whois != 0 ? whois.admin_street : "-" }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{$t('website.admin_city')}}</th>
                                                            <td class="p-2">{{whois != 0 ? whois.admin_city : "-" }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{$t('website.admin_phone')}}</th>
                                                            <td class="p-2">{{whois != 0 ? whois.admin_phone : "-" }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{$t('website.admin_fax')}}</th>
                                                            <td class="p-2">{{whois != 0 ? whois.admin_fax : "-" }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div class="table-responsive pl-2">
                                                <table class="table table-bordered w-100">
                                                    <tbody>
                                                        <tr>
                                                            <th colspan="2" class="h4 bg-secondary text-white">Tech</th>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{$t('website.tech_organization')}}</th>
                                                            <td class="p-2">{{whois != 0 ? whois.tech_name : "-" }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{$t('website.tech_organization')}}</th>
                                                            <td class="p-2">{{whois != 0 ? whois.tech_organization : "-" }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{$t('website.tech_fax')}}</th>
                                                            <td class="p-2">{{whois != 0 ? whois.tech_street : "-" }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{$t('website.tech_city')}}</th>
                                                            <td class="p-2">{{whois != 0 ? whois.tech_city : "-" }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{$t('website.tech_email')}}</th>
                                                            <td class="p-2">{{whois != 0 ? whois.tech_email : "-" }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{$t('website.tech_fax')}}</th>
                                                            <td class="p-2">{{whois != 0 ? whois.tech_fax : "-" }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <section v-if="selectelement.advanced.socmed || selectelement.advanced.ecommerce || selectelement.advanced.exposed || selectelement.education.education || selectelement.education.career || selectelement.website.web">
                                    <div v-if="adv_socmed || adv_ecommerce || adv_exposed[0] || education || career || webinfo" class="html2pdf__page-break"/>
                                    <div class="invoice-title pt-4 pb-1 d-flex justify-content-between align-items-center" v-if="adv_socmed || adv_ecommerce || adv_exposed[0] || education || career || webinfo">
                                        <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                          <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                    </div>
                                    <hr v-if="adv_socmed || adv_ecommerce || adv_exposed[0] || education || career || webinfo" class="mb-4" />
                                    <h4 class="text-center mb-4 text-uppercase font-weight-bolder" v-if="adv_socmed || adv_ecommerce || adv_exposed[0] || education || career || webinfo">{{ $t('advanced.advanced-data') }}</h4>
                                    <div class="mt-4 d-flex">
                                        <div class="w-100">
                                            <div class="table-responsive pr-2" v-if="selectelement.education.education && education">
                                                <table class="table table-bordered w-100">
                                                    <thead>
                                                        <tr>
                                                            <th colspan="2" class="h5 bg-secondary text-white">{{ $t('education.education-info') }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                            <tr>
                                                                <td width="25%">
                                                                {{ $t('education.name') }}
                                                                </td>
                                                                <td>
                                                                {{education == null ? '' : education.nm_pd}}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td width="25%">
                                                                    NIM
                                                                </td>
                                                                <td>
                                                                {{education == null ? '' : education.nipd}}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td width="25%">
                                                                    {{ $t('education.perguruan-tinggi') }}
                                                                </td>
                                                                <td>
                                                                {{education == null ? '' : education.namapt}}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td width="25%">
                                                                    {{ $t('education.jenjang') }}
                                                                </td>
                                                                <td>
                                                                {{education == null ? '' : education.namajenjang}}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td width="25%">
                                                                    {{ $t('education.program-studi') }}
                                                                </td>
                                                                <td>
                                                                {{education == null ? '' : education.namaprodi}}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td width="25%">
                                                                    {{ $t('education.jenis-kelamin') }}
                                                                </td>
                                                                <td>
                                                                {{education == null ? '' : education.jk}}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td width="25%">
                                                                    {{ $t('education.semester-awal') }}
                                                                </td>
                                                                <td>
                                                                {{education == null ? '' : education.mulai_smt}}
                                                                </td>
                                                            </tr>
                                                            <tr v-if="education == null ? '' : education.nm_jns_daftar">
                                                                <td width="25%">
                                                                    {{ $t('education.status-awal') }}
                                                                </td>
                                                                <td>
                                                                {{education == null ? '' : education.nm_jns_daftar}}
                                                                </td>
                                                            </tr>
                                                            <tr v-if="education == null ? '' : education.nama_pt_asal">
                                                                <td width="25%">
                                                                    {{ $t('education.nama-pt-awal') }}
                                                                </td>
                                                                <td>
                                                                {{education == null ? '' : education.nama_pt_asal}}
                                                                </td>
                                                            </tr>
                                                            <tr v-if="education == null ? '' : education.nm_prodi_asal">
                                                                <td width="25%">
                                                                    {{ $t('education.prodi-asal') }}
                                                                </td>
                                                                <td>
                                                                {{education == null ? '' : education.nm_prodi_asal}}
                                                                </td>
                                                            </tr>
                                                            <tr v-if="education == null ? '' : education.ket_keluar">
                                                            <td width="25%">
                                                            {{ $t('education.status') }}  
                                                            </td>
                                                            <td>
                                                            {{education == null ? '' : education.ket_keluar}}
                                                            </td>
                                                            </tr>
                                                            <tr v-if="education == null ? '' : education.tgl_keluar">
                                                            <td width="25%">
                                                            {{ $t('education.tanggal-lulus') }} 
                                                            </td>
                                                            <td>
                                                            <span v-if="education == null ? '' : education.tgl_keluar">{{formatDate(education.tgl_keluar)}} </span>
                                                            </td>
                                                            </tr>
                                                            <tr v-if="education == null ? '' : education.no_seri_ijazah">
                                                            <td width="25%">
                                                            {{ $t('education.nomer-ijazah') }} 
                                                            </td>
                                                            <td>
                                                            {{education == null ? '' : education == null ? '' : education.no_seri_ijazah}}
                                                            </td>
                                                            </tr>
                                                            <tr v-if="education == null ? '' : education.sert_prof">
                                                            <td width="25%">
                                                            {{ $t('education.sertifikasi-profesi') }}
                                                            </td>
                                                            <td>
                                                            {{education == null ? '' : education.sert_prof}}
                                                            </td>
                                                        </tr>
                                                    
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div class="table-responsive pr-2"  v-if="selectelement.education.career && career"> 
                                               <div class="html2pdf__page-break "/>
                                                <table class="table table-bordered w-100 mt-3" style="page-break-inside: avoid;">
                                                    <thead>
                                                        <tr>
                                                            <th colspan="2" class="h5 bg-secondary text-white">{{ $t('education.career-info') }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr style="page-break-inside: avoid;">
                                                            <td width="25%">
                                                            <div class="">
                                                                    {{$t('education.avatar')}}
                                                            </div>
                                                            </td>
                                                            <td>
                                                                <div class="col-sm-10">
                                                                    <img :src="career.profile_picture" alt="" class="img-fluid rounded avatar-md" srcset="">
                                                                </div>
                                                            </td>
                                                        </tr>  
                                                        <tr style="page-break-inside: avoid;">
                                                            <td width="25%">
                                                                {{$t('education.profil_id')}}
                                                            </td>
                                                            <td>
                                                            {{career.profile_id}}
                                                            </td>
                                                        </tr>
                                                        <tr style="page-break-inside: avoid;">
                                                            <td width="20%">
                                                            {{$t('education.first_name')}}
                                                            </td>
                                                            <td>
                                                                {{career.first_name}} 
                                                            </td>
                                                        </tr>
                                                        <tr style="page-break-inside: avoid;">
                                                            <td width="20%">
                                                                {{$t('education.last_name')}}
                                                            </td>
                                                            <td>
                                                            {{career.last_name}}
                                                            </td>
                                                        </tr>                            
                                                        <tr>
                                                            <td width="20%">
                                                                {{$t('education.position')}}
                                                            </td>
                                                            <td>
                                                            <div v-for="(position, index) in profile_positions" :key="index" class="border mb-2 p-2" style="page-break-inside: avoid;">
                                                                <span v-if="position.company"><img :src="position.company.logo" alt="" class="img-fluid rounded avatar-xs mb-1" srcset="" v-if="position.company.logo !== null"> <img src="https://static-exp1.licdn.com/sc/h/3dtfvv2esz58o2zimai1h4v2d" alt="" class="img-fluid rounded avatar-xs mb-1" srcset="" v-else><br> </span> 
                                                                <span v-if="position.company"> <b>{{$t('education.company')}} : </b>{{position.company.name}}  <br></span>
                                                                <span v-if="position.profile_positions"><b>{{$t('education.title')}} :</b> {{position.profile_positions[0].title}}  <br> </span>
                                                                <span v-if="position.profile_positions"> <b>{{$t('education.location')}} : </b> {{position.profile_positions[0].location}}  <br></span>
                                                                <div v-if="position.date"><b  v-if="position.date.start">{{$t('education.start')}} : </b> <span v-if="position.date.start">{{position.date.start.year}} -  {{formatMonth(position.date.start.month)}}</span> <br> </div>
                                                                <div v-if="position.date"><b v-if="position.date.end"> {{$t('education.end')}} : </b> <span v-if="position.date.end">{{position.date.end.year}} -  {{formatMonth(position.date.end.month)}} </span><br> </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="skills[0]" style="page-break-inside: avoid;">
                                                            <td width="20%">
                                                                {{$t('education.skills')}}
                                                            </td>
                                                            <td>
                                                            <span v-for="(sk, index) in skills" :key="index" class="btn btn-sm btn-light mr-1 mb-1 text-secondary">{{sk}} </span>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="certifications.lenght > 0" style="page-break-inside: avoid;">
                                                            <td width="20%">
                                                                {{$t('education.sertifikat')}}
                                                            </td>
                                                            <td>
                                                            <div v-for="(cer, index) in certifications" :key="index" class="border mb-2 p-2">
                                                                <span v-if="cer.company"><img :src="cer.company.logo" alt="" class="img-fluid rounded avatar-sm mb-1" srcset=""><br> </span> 
                                                                <span v-if="cer.name"><b>{{$t('education.name')}} :</b> {{cer.name}} <br> </span>
                                                                <span v-if="cer.date"><b>{{$t('education.year')}} : </b> {{cer.date.start.year}} -  {{formatMonth(cer.date.start.month)}} <br> </span>
                                                                <span v-if="cer.license_number"> <b>{{$t('education.licensi-number')}} : </b>{{cer.license_number}}  <br></span>
                                                                <span v-if="cer.url"><b>{{$t('education.link')}} : </b> <a :href="cer.url" target="_blank" rel="noopener noreferrer"> {{cer.url}} </a><br></span>
                                                                <span v-if="cer.display_source"><b>{{$t('education.source')}} : </b>{{cer.display_source}}<br> </span>
                                                                <span v-if="cer.authority"> <b>{{$t('education.authority')}} : </b>{{cer.authority}}<br> </span>
                                                            </div>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="publications.length > 0" style="page-break-inside: avoid;">
                                                            <td width="20%">
                                                            {{$t('education.publications')}} 
                                                            </td>
                                                            <td>
                                                            <div v-for="(publics, index) in publications" :key="index" class="border mb-2 p-2">
                                                                    <span><b>{{$t('education.headline')}} : </b> <a :href="publics.url" target="_blank" rel="noopener noreferrer">{{publics.name}}</a></span> <br>
                                                                    <span><b> {{$t('education.date')}} : </b><span v-if="publics.date.day">{{publics.date.day}}</span><span v-if="publics.date.month"> {{formatMonth(publics.date.month)}}</span> {{publics.date.year}}</span> <br>
                                                                    <span><b> {{$t('education.publiser')}} : </b>{{publics.publisher}}</span> <br>
                                                                    <b>  {{$t('education.authors')}} : </b><span v-for="(ath, index) in publics.authors" :key="index">({{ath.first_name}} {{ath.last_name}}, {{ath.headline}}, {{ath.type}}), </span> <br>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="html2pdf__page-break" v-if="selectelement.advanced.socmed || selectelement.advanced.ecommerce"/>
                                    <div class="mt-4 d-flex">
                                        <div class="w-100">
                                            <div class="table-responsive pr-2" v-if="selectelement.advanced.socmed && adv_socmed"> 
                                                <table class="table table-bordered w-100">
                                                    <thead>
                                                        <tr>
                                                            <th colspan="2" class="h5 bg-secondary text-white">{{ $t('advanced.social-media-database') }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td width="25%"><b>{{$t('advanced.name')}}</b></td>
                                                            <td width="75%">
                                                            {{adv_socmed.first_name + " " + adv_socmed.last_name}} 
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="25%"><b>{{$t('advanced.gender')}}</b></td>
                                                            <td width="75%">{{adv_socmed.gender}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="25%"><b>{{$t('advanced.phone')}}</b></td>
                                                            <td width="75%">{{adv_socmed.phone}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="25%"><b>{{$t('advanced.hometown')}}</b></td>
                                                            <td width="75%">{{adv_socmed.hometown}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="25%"><b>{{$t('advanced.city')}}</b></td>
                                                            <td width="75%">{{adv_socmed.current_city}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="25%"><b>{{$t('advanced.work')}}</b></td>
                                                            <td width="75%">{{adv_socmed.work}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="25%"><b>Status</b></td>
                                                            <td width="75%">{{adv_socmed.status}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div class="table-responsive pr-2" v-if="selectelement.advanced.ecommerce && adv_ecommerce">
                                                <table class="table table-bordered w-100">
                                                    <thead>
                                                        <tr>
                                                            <th colspan="2" class="h5 bg-secondary text-white">{{ $t('advanced.ecommerce-database') }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                            <tr>
                                                            <td width="25%"><b>{{$t('advanced.name')}}</b></td>
                                                            <td width="80%">
                                                                {{adv_ecommerce.full_name}} 
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width="25%"><b>{{$t('advanced.gender')}}</b></td>
                                                            <td width="75%">{{adv_ecommerce.sex}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="25%"><b>{{$t('advanced.phone')}}</b></td>
                                                            <td width="75%">{{adv_ecommerce.phone}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="25%"><b>{{$t('advanced.email')}}</b></td>
                                                            <td width="75%">{{adv_ecommerce.user_email}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="25%"><b>{{$t('advanced.hoobies')}}</b></td>
                                                            <td width="75%">{{adv_ecommerce.hobbies}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="25%"><b>{{$t('advanced.bithday')}}</b></td>
                                                            <td width="75%">{{adv_ecommerce.birth_date}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="25%"><b>Status</b></td>
                                                            <td width="75%">{{adv_ecommerce.status}}</td>
                                                        </tr>
                                                    
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div class="html2pdf__page-break" v-if="selectelement.advanced.exposed &&  adv_exposed[0]"/>
                                            <div class="boorder pr-2" v-if="selectelement.advanced.exposed &&  adv_exposed[0]">    
                                            <table class="table table-bordered w-100 mt-3">
                                                <thead>
                                                    <tr>
                                                        <th colspan="2" class="h5 bg-secondary text-white">{{ $t('advanced.exposed') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <div class="row my-2 mx-1" v-if="adv_exposed[0]">
                                                    <div
                                                        v-for="(e, index) in adv_exposed"
                                                        :key="index"
                                                        class="col-sm-6 py-2"
                                                        style="page-break-inside: avoid;"
                                                    >
                                                        <div
                                                        class="
                                                            d-block
                                                            border border-primary
                                                            rounded
                                                            p-2
                                                            h-100
                                                        "
                                                        >
                                                        <div
                                                            class="
                                                            d-flex
                                                            align-items-center
                                                            justify-content-between
                                                            "
                                                        >
                                                            <h5 class="text-truncate">{{ e.source }}</h5>
                                                            <i
                                                            v-if="e.has_password == 0"
                                                            class="bx bxs-lock bx-sm"
                                                            ></i>
                                                            <i
                                                            v-if="e.has_password == 1"
                                                            class="text-success bx bxs-lock-open bx-sm"
                                                            ></i>
                                                        </div>
                                                        <hr />
                                                        <div class="text-xs">
                                                            <small v-if="e.email"
                                                            >Email : {{ e.email }}</small
                                                            ><br />
                                                            <small v-if="e.has_password"
                                                            >Password : {{ e.password }}</small
                                                            ><br />
                                                            <small v-if="e.has_password"
                                                            >Password Hash : {{ e.hash }}</small
                                                            >
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                </tbody>
                                            </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="html2pdf__page-break" v-if="selectelement.website.web && webinfo" />
                                    <div class="mt-4 d-flex" v-if="selectelement.website.web && webinfo">
                                        <div class="w-100">
                                            <div class="table-responsive pr-2"> 
                                                <table class="table table-bordered w-100">
                                                    <thead>
                                                        <tr>
                                                            <th colspan="2" class="h5 bg-secondary text-white">{{ $t('website.website-info') }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th class="p-2">Domain</th>
                                                            <td class="p-2">{{webinfo.domain_name}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.ip_address') }}</th>
                                                            <td class="p-2">{{webinfo.ip_address}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.visitors') }}</th>
                                                            <td class="p-2">{{webinfo.visitors}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.ip_location') }}</th>
                                                            <td class="p-2">{{webinfo.ip_location}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.ip_reserve_dns') }}</th>
                                                            <td class="p-2">{{webinfo.ip_reverse_dns}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.hosting_company') }}</th>
                                                            <td class="p-2">{{webinfo.hosting_company}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.hosting_ip_range') }}</th>
                                                            <td class="p-2">{{webinfo.hosting_ip_range}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.hosting_address') }}</th>
                                                            <td class="p-2">{{webinfo.hosting_address}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.hosting_country') }}</th>
                                                            <td class="p-2">{{webinfo.hosting_country}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.hosting_phone') }}</th>
                                                            <td class="p-2">{{webinfo.hosting_phone}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">CIDR</th>
                                                            <td class="p-2">{{webinfo.cidr}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.hosting_cidr') }}</th>
                                                            <td class="p-2">{{webinfo.hosting_cidr}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <!-- <div class="table-responsive pr-2">
                                                <table class="table table-bordered w-100">
                                                    <thead>
                                                        <tr>
                                                            <th colspan="2" class="h5 bg-secondary text-white">{{ $t('website.geografis-info') }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.region') }}</th>
                                                            <td class="p-2">{{iplocation.region}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.country_name') }}</th>
                                                            <td class="p-2">{{iplocation.country_name}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.postal') }}</th>
                                                            <td class="p-2">{{(iplocation.postal_code)}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.latitude') }}</th>
                                                            <td class="p-2">{{iplocation.latitude}},  {{iplocation.longitude}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="p-2">{{ $t('website.timezone') }}</th>
                                                            <td class="p-2">{{iplocation.timezone}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div> -->
                                        </div>
                                    </div>
                                </section>
                                
                                <div v-if="selectelement.news.list.length > 0">
                                    <div class="html2pdf__page-break"/>
                                        <div class="invoice-title px-0 pt-4 pb-1 d-flex justify-content-between align-items-center">
                                            <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                              <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                        </div>
                                    <hr class="mb-4" />
                                    <h4 class="text-center mb-4 text-uppercase font-weight-bolder">{{ $t('news.related-news') }}</h4>
                                    <div class="table-responsive">
                                        <table class="table table-bordered" style="page-break-inside: avoid;">
                                            <tbody>
                                                <tr v-for="(nw, index) in selectelement.news.list" :key="index" style="page-break-inside: avoid;">
                                                    <td>
                                                        <div class="row">
                                                            <div class="col-3">
                                                                 <img :src="base64img_news[index]" alt="" width="100%" class="img-fluid rounded">
                                                            </div>
                                                            <div class="col-9">
                                                                <span><b>{{ $t('news.title') }} :</b> {{nw.title}} <br></span>
                                                                <span><b>{{ $t('news.published_at') }} :</b><span class="text-secondary"> {{nw.source}} - {{formatDate(nw.published_at)}}</span><br></span>
                                                                <span><b>Url : </b> <a :href="nw.url" target="_blank" rel="noopener noreferrer"> {{nw.url}}</a></span>
                                                            </div> 
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="html2pdf__page-break"/>
                                        <div class="invoice-title px-0 pt-4 pb-1 d-flex justify-content-between align-items-center">
                                            <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                              <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                        </div>
                                    <hr class="mb-4" />
                                    <h4 class="text-center mb-4 text-uppercase font-weight-bolder">{{ $t('report.news-analystic') }}</h4>
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="clearfix">
                                                <h5 class="card-title mb-4"> {{ $t('news.source') }}</h5>
                                                <hr>
                                            </div>
                                            <div v-if="!loadingNews.source">
                                                <div v-if="!nodata.source">
                                                    <apexchart
                                                    ref="source"
                                                    class="apex-charts"
                                                    height="400"
                                                    type="donut"
                                                    dir="ltr"
                                                    :series="seriesSource"
                                                     :options="{
                                                        plotOptions: {
                                                            pie: {
                                                                    donut: {
                                                                    labels: {
                                                                        show: true,
                                                                        name: {
                                                                            show: true,
                                                                            fontSize: '22px',
                                                                            fontFamily: 'Rubik',
                                                                            color: theme == 'dark'? '#F8F8FB' : '#343a40',
                                                                        },
                                                                        value: {
                                                                            show: true,
                                                                            fontSize: '16px',
                                                                            fontFamily: 'Helvetica, Arial, sans-serif',
                                                                            color: theme == 'dark'? '#F8F8FB' : '#343a40',
                                                                        },
                                                                        total: {
                                                                            show: true,
                                                                            label: 'Total',
                                                                            color: theme == 'dark'? '#F8F8FB' : '#343a40'
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                        },
                                                        labels: labelsSource,
                                                        colors: colorsSource,
                                                        legend: {
                                                            show: true,
                                                            position: 'bottom',
                                                            horizontalAlign: 'center',
                                                            verticalAlign: 'middle',
                                                            floating: false,
                                                            fontSize: '14px',
                                                            offsetX: 0,
                                                            offsetY: -10,
                                                            labels: {
                                                                colors: theme == 'dark'? '#F8F8FB' : '#343a40',
                                                            }
                                                        },
                                                        responsive: [{
                                                            breakpoint: 600,
                                                            options: {
                                                                chart: {
                                                                    height: 240
                                                                },
                                                                legend: {
                                                                    show: false
                                                                },
                                                            }
                                                        }]
                                                    }"
                                                    />
                                                </div>
                                                <div class="d-flex flex-column justify-content-center align-items-center" style="margin-top:15%;margin-bottom:15%;" v-else>
                                                    <i class="bx bxs-doughnut-chart bx-lg"></i>
                                                    <span> {{ $t('all.dnf') }}</span>
                                                </div>
                                            </div>
                                            <div class="d-flex flex-column justify-content-center align-items-center" style="margin-top:15%;margin-bottom:15%;" v-else>
                                                <i class="bx bx-loader-alt bx-lg bx-spin"></i>
                                            </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="clearfix">
                                                    <h5 class="card-title mb-4"> {{ $t('news.sentiment') }}</h5>
                                                    <hr>
                                                </div>
                                                <div v-if="!loadingNews.allsentiment">
                                                    <div v-if="!nodata.allsentiment">
                                                        <apexchart
                                                            ref="senti"
                                                            class="apex-charts"
                                                            height="400"
                                                            type="pie"
                                                            dir="ltr"
                                                            :series="seriesSentiment"
                                                            :options="{
                                                                labels: labelsSentiment,
                                                                colors: colorsSentiment,
                                                                legend: {
                                                                    show: true,
                                                                    position: 'bottom',
                                                                    horizontalAlign: 'center',
                                                                    verticalAlign: 'middle',
                                                                    floating: false,
                                                                    fontSize: '14px',
                                                                    offsetX: 0,
                                                                    offsetY: -10,
                                                                    labels: {
                                                                        colors: theme == 'dark'? '#F8F8FB' : '#343a40',
                                                                    }
                                                                },
                                                                responsive: [{
                                                                    breakpoint: 600,
                                                                    options: {
                                                                        chart: {
                                                                            height: 500
                                                                        },
                                                                        legend: {
                                                                            show: false
                                                                        },
                                                                    }
                                                                }]
                                                            }"
                                                        />
                                                    </div>
                                                    <div class="d-flex flex-column justify-content-center align-items-center" style="margin-top:15%;margin-bottom:15%;" v-else>
                                                        <i class="bx bxs-pie-chart-alt-2 bx-lg"></i>
                                                        <span>{{ $t('all.dnf') }}</span>
                                                    </div>
                                                </div>
                                                <div class="d-flex flex-column justify-content-center align-items-center" style="margin-top:15%;margin-bottom:15%;" v-else>
                                                    <i class="bx bx-loader-alt bx-lg bx-spin"></i>
                                                </div>
                                            </div>
                                    </div>
                                </div>

                                <section v-if="selectelement.sna">
                                    <div class="html2pdf__page-break"/>
                                        <div class="invoice-title px-0 pt-4 pb-1 d-flex justify-content-between align-items-center">
                                            <img src="@/assets/images/osint-horizontal.png" alt="logo" width="100" />
                                              <h4 class="text-uppercase">{{ $t('report.report-analysis') }}</h4>
                                        </div>
                                        <hr class="mb-4" />
                                        <!-- <h4 class="text-center mb-4 text-uppercase font-weight-bolder">{{ $t('report.social-network-analys') }}</h4> -->
                                        <h4 class="text-center mb-4 text-uppercase font-weight-bolder">Canvas</h4>
                                        <cytoscape
                                            v-if="dataRelationSNA"
                                            class="mt-4"
                                            ref="cyRef"
                                            :afterCreated="afterCreatedSNA"
                                            :preConfig="preConfigSNA"
                                            :config="configSNA">
                                        </cytoscape>
                                        <div>
                                            
                                        <div class="html2pdf__page-break"/>
                                        <div class="row p-2 mt-5">
                                            <div class="col-4 p-1" v-if="degrees">
                                            <p class="h5">Degree</p>
                                            <table class="table table-bordered mb-0" >
                                                <thead>
                                                    <tr>
                                                        <th width="80%">Node</th>
                                                        <th>{{ $t('overview.score') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(value, key, index) in degrees" :key="key" :class="index == 0 ? 'bg-primary text-white':''">
                                                        <td>{{key}}</td>
                                                        <td>{{value.toFixed(2) }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            </div>
                                            <div class="col-4 p-1" v-if="betweeness">
                                                <p class="h5"> Betweeness</p>
                                                <table class="table table-bordered mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th width="80%">Node</th>
                                                            <th>{{ $t('overview.score') }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(value, key, index) in betweeness" :key="key" :class="index == 0 ? 'bg-warning text-white':''">
                                                            <td>{{key}}</td>
                                                            <td>{{value.toFixed(2) }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div class="col-4 p-1 " v-if="closeness">
                                                <p class="h5">Closeness</p>
                                                <table class="table table-bordered mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th width="80%">Node</th>
                                                            <th>{{ $t('overview.score') }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(value, key, index) in closeness" :key="key" :class="index == 0 ? 'bg-success text-white':''">
                                                            <td>{{key}}</td>
                                                            <td>{{value.toFixed(2) }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                                </div>
                            </div>
                        </section>
                    </vue-html2pdf>
                </simplebar>
            </div>
        </div>
    </Layout>
</template>

<script>
import axios from 'axios';
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import TargetService from "@/helpers/target-profile.service";
import PreferenceService from "@/helpers/preference.service.js";
import PhoneService from "@/helpers/phone.service.js";
import InstaService from '@/helpers/osintgram.service';
import TwintService from "@/helpers/twint.service.js";
import WebsiteService from "@/helpers/website.service.js";
import NewsService from "@/helpers/news.service.js";
import SherlockService from "@/helpers/sherlock.service.js";
import EducationService from "@/helpers/education.service";
import AdvancedService from "@/helpers/advanced.service";
import cola from 'cytoscape-cola';
import cytoscape from 'cytoscape'
import appConfig from "@/app.config";
import simplebar from "simplebar-vue";
import moment from 'moment';

export default { 
    page: {
        title: "Report",
        meta: [{ name: "description", content: appConfig.description }]
    },
 
    components: { Layout, PageHeader, simplebar},
    data() {
        const gaugeOptions = {
            chart: {
                height: 200,
                type: "radialBar",
                offsetY: 0,
            },
            plotOptions: {
                radialBar: {
                track: {
                background: 'transparent'
                },
                hollow: {
                    margin: 5,
                    size: '50%',
                    background:  localStorage.getItem("theme") == "dark" ? "#000000" : "#ffffff",
                    image: undefined,
                    imageWidth: 150,
                    imageHeight: 150,
                    imageOffsetX: 0,
                    imageOffsetY: 0,
                    imageClipped: true,
                    position: 'front',
                    dropShadow: {
                        enabled: false,
                        top: 0,
                        left: 0,
                        blur: 3,
                        opacity: 0.5
                    }
                },
                startAngle: -135,
                endAngle: 135,
                dataLabels: {
                    name: {
                    fontSize: "12px",
                    color: localStorage.getItem("theme") == "dark" ? "#FFFFFF" : "#000000",
                    offsetY: 60,
                    },
                    value: {
                    offsetY: 0,
                    fontSize: "16px",
                    color: localStorage.getItem("theme") == "dark" ? "#FFFFFF" : "#000000",
                    formatter: function (val) {
                        return val;
                    },
                    },
                },
                },
            },
            fill: {
                opacity: 1.5,
                type: "gradient",
                colors: [localStorage.getItem("theme") == "dark" ? "#FFFFFF" : "#000000"],
                gradient: {
                shade: "dark",
                shadeIntensity: 0.15,
                inverseColors: false,
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 50, 65, 91],
                },
            },
            stroke: {
                dashArray: 4,
            },
            labels: [this.$t("overview.table.all.score")],
        }

        let v_id = this.$route.params.id;
        let title_target = this.$route.params.tt;
        let img_target = this.$route.params.img;
        return {
            avatar_ig: process.env.VUE_APP_BASE_API_URL_OSINT+'stream-profil/?name=',
            theme: localStorage.getItem('theme'),
            id: this.$route.params.id,
            v_id: v_id,
            img_target: img_target,
            title_target: title_target,
            title: "Report",
            urlimage: process.env.VUE_APP_BASE_API_URL + 'target/image-project?name=',
            items: [
                {
                text: "Project",
                href: "/"
                },
                {
                text: "Report",
                active: true
                }
            ],
            labelsSource:[],
            colorsSource:[],
            gaugeSeries: [],
            elastic:"",
            gaugeOptions: gaugeOptions,
            selectelement: {
                citizen : true,
                phone : true,
                tag : true,
                graph : false,
                sna : false,
                sosmed : {
                    twitter : false,
                    instagram : false,
                    telegram : false,
                },
                image : {
                    show : false,
                    list : []
                },
                timeline : {
                    show : false,
                    list : []
                },
                news : {
                    show : false,
                    list : []
                },
                website : {
                    web : false,
                    cms : false,
                    whois : false,
                },
                education : {
                    career : false,
                    education : false,
                },
                advanced : {
                    socmed : false,
                    ecommerce : false,
                    exposed : false,
                }
            },
            target:[],
            id_template:"",
            template:[],
            citizen:[],
            instagram:[],
            twitter:[],
            telegram:[],
            private_data:[],
            data_breach:"",
            education:"",
            career:"",
            adv_exposed:"",
            adv_socmed:"",
            adv_ecommerce:"",
            skills:"",
            profile_positions:"",
            certifications:"",
            publications:"",
            private_web:"",
            webinfo:"",
            iplocation:"",
            subdomain:"",
            cms: "",
            service: "",
            whois: "",
            tags:[],
            media:[],
            timeline:[],
            news:[],
            created_at_timeline_twitter:'',
            created_at_timeline_instagram:'',
            account_twitter:'',
            account_instagram:'',
            enableDownload: '',
            previewModal: '',
            loading: {
                generate: false,
                print: false
            },
            loadingNews:{
                statsentiment: false,
                statnews: false,
                source: false,
                allsentiment: false,
            },
            nodata:{
                statsentiment: false,
                statnews: false,
                source: false,
                allsentiment: false,
            },
            filename: 'report',
            dataRelation: false, 
            dataRelationSNA: false, 
            dataWordCloud: false, 
            dataFollow: false,
            dataMention:false,
            config : {
                layout: { 
                name: "cola",
                animate: false,
                fit: true,
                padding: 15, 
                avoidOverlap: true,
                autoungrabify: true
                },
                style: [
                {
                    selector: "node[id='"+v_id+"']",
                    style: { 
                    "width": "70px", 
                    "height": "70px", 
                    "content": "data(label)", 
                    "text-transform": "uppercase", 
                    "color": "#555555", 
                    "font-size": "16px", 
                    "font-weight": "bold",
                    "text-valign": "center", 
                    "text-halign": "center", 
                    "background-color": "#000", 
                    "text-outline-color": "#000", 
                    "text-outline-width": "2px", 
                    "color": "#fff", 
                    "overlay-padding": "6px", 
                    "z-index": "10" 
                    }
                },
                {
                    selector: "node[id='2rp']",
                    style: { 
                    "width": "50px", 
                    "height": "50px", 
                    "content": "data(label)", 
                    "text-transform": "uppercase", 
                    "color": "#555555", 
                    "font-size": "14px", 
                    "font-weight": "bold",
                    "text-valign": "center", 
                    "text-halign": "center", 
                    "background-color": "#34c38f", 
                    "text-outline-color": "#34c38f", 
                    "text-outline-width": "2px", 
                    "color": "#fff", 
                    "overlay-padding": "6px", 
                    "z-index": "10" 
                    }
                },
                {
                    selector: "node[parent_node='relation']",
                    style: { 
                    "width": "30px", 
                    "height": "30px", 
                    "content": "data(label)", 
                    "text-transform": "lowercase", 
                    "color": "#555555", 
                    "font-size": "12px",
                    "text-valign": "center", 
                    "text-halign": "center", 
                    "background-color": "#3b7862", 
                    "text-outline-color": "#3b7862", 
                    "text-outline-width": "2px", 
                    "color": "#fff", 
                    "overlay-padding": "6px", 
                    "z-index": "10" 
                    }
                },
                {
                    selector: "node[id='3wc']",
                    style: { 
                    "width": "50px", 
                    "height": "50px", 
                    "content": "data(label)", 
                    "text-transform": "uppercase", 
                    "color": "#555555", 
                    "font-size": "14px", 
                    "font-weight": "bold",
                    "text-valign": "center", 
                    "text-halign": "center", 
                    "background-color": "#50a5f1", 
                    "text-outline-color": "#50a5f1", 
                    "text-outline-width": "2px", 
                    "color": "#fff", 
                    "overlay-padding": "6px", 
                    "z-index": "10" 
                    }
                },
                {
                    selector: "node[parent_node='word']",
                    style: { 
                    "width": "30px", 
                    "height": "30px", 
                    "content": "data(label)", 
                    "text-transform": "lowercase", 
                    "color": "#555555", 
                    "font-size": "12px",
                    "text-valign": "center", 
                    "text-halign": "center", 
                    "background-color": "#2d577d", 
                    "text-outline-color": "#2d577d", 
                    "text-outline-width": "2px", 
                    "color": "#fff", 
                    "overlay-padding": "6px", 
                    "z-index": "10" 
                    }
                },
                {
                    selector: "node[id='4flwng']",
                    style: { 
                    "width": "50px", 
                    "height": "50px", 
                    "content": "data(label)", 
                    "text-transform": "uppercase", 
                    "color": "#555555", 
                    "font-size": "14px", 
                    "font-weight": "bold",
                    "text-valign": "center", 
                    "text-halign": "center", 
                    "background-color": "#f46a6a", 
                    "text-outline-color": "#f46a6a", 
                    "text-outline-width": "2px", 
                    "color": "#fff", 
                    "overlay-padding": "6px", 
                    "z-index": "10" 
                    }
                },
                {
                    selector: "node[parent_node='following']",
                    style: { 
                    "width": "30px", 
                    "height": "30px", 
                    "content": "data(label)", 
                    "text-transform": "lowercase", 
                    "color": "#555555", 
                    "font-size": "12px",
                    "text-valign": "center", 
                    "text-halign": "center", 
                    "background-color": "#943737", 
                    "text-outline-color": "#943737", 
                    "text-outline-width": "2px", 
                    "color": "#fff", 
                    "overlay-padding": "6px", 
                    "z-index": "10" 
                    }
                },
                {
                    selector: "node[id='5flwr']",
                    style: { 
                    "width": "50px", 
                    "height": "50px", 
                    "content": "data(label)", 
                    "text-transform": "uppercase", 
                    "color": "#555555", 
                    "font-size": "14px", 
                    "font-weight": "bold",
                    "text-valign": "center", 
                    "text-halign": "center", 
                    "background-color": "#f1b44c", 
                    "text-outline-color": "#f1b44c", 
                    "text-outline-width": "2px", 
                    "color": "#fff", 
                    "overlay-padding": "6px", 
                    "z-index": "10" 
                    }
                },
                {
                    selector: "node[parent_node='follower']",
                    style: { 
                    "width": "30px", 
                    "height": "30px", 
                    "content": "data(label)", 
                    "text-transform": "lowercase", 
                    "color": "#555555", 
                    "font-size": "12px",
                    "text-valign": "center", 
                    "text-halign": "center", 
                    "background-color": "#916d30", 
                    "text-outline-color": "#916d30", 
                    "text-outline-width": "2px", 
                    "color": "#fff", 
                    "overlay-padding": "6px", 
                    "z-index": "10" 
                    }
                },
                {
                    selector: "node[id='6mention']",
                    style: { 
                    "width": "50px", 
                    "height": "50px", 
                    "content": "data(label)", 
                    "text-transform": "uppercase", 
                    "color": "#555555", 
                    "font-size": "14px", 
                    "font-weight": "bold",
                    "text-valign": "center", 
                    "text-halign": "center", 
                    "background-color": "#F6812B", 
                    "text-outline-color": "#F76300", 
                    "text-outline-width": "2px", 
                    "color": "#fff", 
                    "overlay-padding": "6px", 
                    "z-index": "10" 
                    }
                },
                {
                    selector: "node[parent_node='topmention']",
                    style: { 
                    "width": "30px", 
                    "height": "30px", 
                    "content": "data(label)", 
                    "text-transform": "lowercase", 
                    "color": "#555555", 
                    "font-size": "12px",
                    "text-valign": "center", 
                    "text-halign": "center", 
                    "background-color": "#F76300", 
                    "text-outline-color": "#F76300", 
                    "text-outline-width": "2px", 
                    "color": "#fff", 
                    "overlay-padding": "6px", 
                    "z-index": "10" 
                    }
                },
                {
                    selector: "edge",
                    style: {
                    width: 2,
                    "line-color": "#eeeeee",
                    "target-arrow-color": "#eeeeee",
                    }
                },
                {
                    selector: "edge[source='2rp']",
                    style: {
                    width: 2,
                    "line-color": "#34c38f",
                    "target-arrow-color": "#34c38f",
                    }
                },
                {
                    selector: "edge[target='2rp']",
                    style: {
                    width: 2,
                    "line-color": "#3b7862",
                    "target-arrow-color": "#3b7862",
                    }
                },
                {
                    selector: "edge[source='3wc']",
                    style: {
                    width: 2,
                    "line-color": "#50a5f1",
                    "target-arrow-color": "#50a5f1",
                    }
                },
                {
                    selector: "edge[target='3wc']",
                    style: {
                    width: 2,
                    "line-color": "#2d577d",
                    "target-arrow-color": "#2d577d",
                    }
                },
                {
                    selector: "edge[source='4flwng']",
                    style: {
                    width: 2,
                    "line-color": "#f46a6a",
                    "target-arrow-color": "#f46a6a",
                    }
                },
                {
                    selector: "edge[target='4flwng']",
                    style: {
                    width: 2,
                    "line-color": "#943737",
                    "target-arrow-color": "#943737",
                    }
                },
                {
                    selector: "edge[source='5flwr']",
                    style: {
                    width: 2,
                    "line-color": "#f1b44c",
                    "target-arrow-color": "#f1b44c",
                    }
                },
                {
                    selector: "edge[target='5flwr']",
                    style: {
                    width: 2,
                    "line-color": "#916d30",
                    "target-arrow-color": "#916d30",
                    }
                },
                    {
                    selector: "edge[source='6mention']",
                    style: {
                    width: 2,
                    "line-color": "#943737",
                    "target-arrow-color": "#F76300",
                    }
                },
                {
                    selector: "edge[target='6mention']",
                    style: {
                    width: 2,
                    "line-color": "#943737",
                    "target-arrow-color": "#F76300",
                    }
                },
                ],
                elements:{
                nodes:[
                    {
                    "data":{
                        "id":"2rp",
                        "label":"Relation"
                    },
                    "grabbable": false
                    },
                    {
                    "data":{
                        "id":"3wc",
                        "label":"Word Cloud"
                    },
                    "grabbable": false
                    },
                    {
                    "data":{
                        "id":"4flwng",
                        "label":"Following"
                    },
                    "grabbable": false
                    },
                    {
                    "data":{
                        "id":"5flwr",
                        "label":"Follower"
                    },
                    "grabbable": false
                    },
                    {
                    "data":{
                        "id":"6mention",
                        "label":"Top Mention"
                    },
                    "grabbable": false
                    },
                ],
                edges:[
                    {
                    "data":{
                        "source":"2rp",
                        "target": v_id
                    },
                    "grabbable": false
                    },
                    {
                    "data":{
                        "source":"3wc",
                        "target": v_id
                    },
                    "grabbable": false
                    },
                    {
                    "data":{
                        "source":"4flwng",
                        "target": v_id
                    },
                    "grabbable": false
                    },
                    {
                    "data":{
                        "source":"5flwr",
                        "target": v_id
                    },
                    "grabbable": false
                    },
                    {
                    "data":{
                        "source":"6mention",
                        "target": v_id
                    },
                    "grabbable": false
                    },
                ]
                }
            },

            configSNA : {
                layout: { 
                    name: "breadthfirst",
                    animate: false,
                    fit: true,
                    padding: 15,
                    avoidOverlap: true
                },
                style: [
                {
                    selector: "node[id='"+v_id+"']",
                    style: { 
                    "width": "70px", 
                    "height": "70px", 
                    "content": "data(label)", 
                    "text-transform": "uppercase", 
                    "color": "#555555", 
                    "font-size": "16px", 
                    "font-weight": "bold",
                    "text-valign": "bottom", 
                    "text-halign": "center", 
                    "text-outline-color": "#000", 
                    "text-outline-width": "2px", 
                    "color": "#fff", 
                    "overlay-padding": "6px", 
                    "z-index": "10" ,
                    'background-image': process.env.VUE_APP_BASE_API_URL_IMAGE+img_target,
                    'background-width' : '70px',
                    'background-height' : '70px',
                    "border-color": "#000",
                    "border-opacity": "1",
                    "border-width": "5px"
                    }
                },
                
                {
                    selector: "edge",
                    style: {
                    width: 2,
                    "line-color": "#eeeeee",
                    "target-arrow-color": "#eeeeee",
                    }
                },
                
                ],
                elements:{
                    nodes:[
                        {
                        "data":{
                            "id": v_id,
                            "label": title_target
                        },
                        "grabbable": false
                        }
                    ],
                    edges:[]
                },
            },
            degrees: [],
            betweeness: [],
            closeness: [],
            labelsSource: [],
            seriesSource: [],
            colorsSource: [],
            labelsSentiment: [],
            seriesSentiment: [],
            colorsSentiment: [],
            seriesSentimentFilter:[
                {
                    name: 'Positive',
                    data: []
                }, {
                    name: 'Nuetral',
                    data: []
                }, {
                    name: 'Negative',
                    data: []
                }
            ],
            newsSentiment: [],
            newsSource: [],
            // optionsSentiment: {
            //     labels: [],
            //     colors: [],
            //     legend: {
            //         show: true,
            //         position: 'bottom',
            //         horizontalAlign: 'center',
            //         verticalAlign: 'middle',
            //         floating: false,
            //         fontSize: '14px',
            //         offsetX: 0,
            //         offsetY: -10,
            //         labels: {
            //             colors: localStorage.getItem('theme') == 'dark'? '#F8F8FB' : '#343a40',
            //         }
            //     },
            //     responsive: [{
            //         breakpoint: 600,
            //         options: {
            //             chart: {
            //                 height: 500
            //             },
            //             legend: {
            //                 show: false
            //             },
            //         }
            //     }]
            // },
            // optionsSource: {
            //     plotOptions: {
            //         pie: {
            //                 donut: {
            //                 labels: {
            //                     show: true,
            //                     name: {
            //                         show: true,
            //                         fontSize: '22px',
            //                         fontFamily: 'Rubik',
            //                         color: localStorage.getItem('theme') == 'dark'? '#F8F8FB' : '#343a40',
            //                     },
            //                     value: {
            //                         show: true,
            //                         fontSize: '16px',
            //                         fontFamily: 'Helvetica, Arial, sans-serif',
            //                         color: localStorage.getItem('theme') == 'dark'? '#F8F8FB' : '#343a40',
            //                     },
            //                     total: {
            //                         show: true,
            //                         label: 'Total',
            //                         color: localStorage.getItem('theme') == 'dark'? '#F8F8FB' : '#343a40'
            //                     }
            //                 }
            //             }
            //         },
            //     },
            //     labels: [],
            //     colors: [],
            //     legend: {
            //         show: true,
            //         position: 'bottom',
            //         horizontalAlign: 'center',
            //         verticalAlign: 'middle',
            //         floating: false,
            //         fontSize: '14px',
            //         offsetX: 0,
            //         offsetY: -10,
            //         labels: {
            //             colors: localStorage.getItem('theme') == 'dark'? '#F8F8FB' : '#343a40',
            //         }
            //     },
            //     responsive: [{
            //         breakpoint: 600,
            //         options: {
            //             chart: {
            //                 height: 240
            //             },
            //             legend: {
            //                 show: false
            //             },
            //         }
            //     }]
            // },
            base64img_news: []
        };
    },
    computed:{
        domain_name(){
            return this.whois.domain_name ?? "-";
        },
        htmlToPdfOptions() {
            return {
                image: {type: 'jpeg', quality: 0.99},
                html2canvas: {
                dpi: 192, 
                letterRendering: true,
                allowTaint : false,
                useCORS: true,
                logging: true
                }
            }
        }
    },
    methods:{
        getPreferences(){
        PreferenceService.getAllElastic()
        .then((response) => {
            this.elastic = response.data.data[0].ip_address;
            this.getUserTimelineTwitter();
            this.getWordCloud();
            this.getTopFollow();
            this.getTopMention();
        })
        .catch((err) => {
            console.log(err);
        });
    },

        generateReport () {
            this.loading.generate = true;
            this.enableDownload = true;
            this.previewModal = false;
            this.filename = this.target.title.replaceAll(' ', '_').toLowerCase();
            setTimeout(() => {
                this.loading.generate = false;
                this.$refs.html2Pdf.generatePdf();
            }, 1000);
        },
        printReport () {
            this.loading.print = true;
            this.enableDownload = false;
            this.previewModal = true;
            setTimeout(() => {
                this.loading.print = false;
                this.$refs.html2Pdf.generatePdf();
            }, 1000);
            // console.log('print');
        },
        async getTargetDetail(){
            await TargetService.getDetailTarget(this.id)
            .then(response => {
                // console.log('detail tar ==> ', response);
                this.getBreach(response.data.data.id_target);
                this.target = response.data.data;
                this.gaugeSeries = [response.data.data.category_score];
                this.citizen = response.data.data.citizen;
                this.private_data = response.data.data.private_data;
                this.education = response.data.data.education;
                this.career = response.data.data.linkedin;
                this.template = response.data.data.template;
                this.id_template = response.data.data.id_template;
                this.adv_socmed = response.data.data.advanced_fb;
                this.adv_ecommerce = response.data.data.advanced_tokped;

                this.skills = JSON.parse(response.data.data.linkedin?.skills ?? JSON.stringify([]));
                this.profile_positions = JSON.parse(response.data.data.linkedin?.profile_positions ?? JSON.stringify([]));
                this.certifications = JSON.parse(response.data.data.linkedin?.certifications ?? JSON.stringify([]));
                this.publications = JSON.parse(response.data.data.linkedin?.publications ?? JSON.stringify([]));
                this.instagram = response.data.data.instagram;
                this.telegram = response.data.data.telegram;
                this.twitter = response.data.data.twitter;
                this.private_web = response.data.data.private_web[0];
                this.webinfo = response.data.data.private_web[0]?.webinfo ;
                this.iplocation = response.data.data.private_web[0]?.iplocation;
                this.cms = response.data.data.private_web[0]?.cms;
                this.service = response.data.data.private_web[0]?.service;
                this.whois = response.data.data.private_web[0]?.whois ?? [];
                this.config.elements.nodes.push({"data" : {"id" : this.id, "label" : this.target.title}, "grabbable": false})
                var json = JSON.parse('['+this.target.relation_profile+']');
                json.forEach((val) => {
                    const data_nodes = {"data":{"id": val.id, "label":val.name, "parent_node": "relation", "id_target": val.id}, "grabbable": false};
                    this.config.elements.nodes.push(data_nodes);
                    const data_edges = {"data":{"source":val.id, "target": '2rp'}, "grabbable": false};
                    this.config.elements.edges.push(data_edges);
                });
            })
            .catch(err => {
                console.log('d target -> ',err);
            });
            this.dataRelation = true;
            await this.getWebsiteDetail();
            await this.getTags();
        },
        getTags(){
            if (this.private_data && this.private_data.id_contact) {
                PhoneService.detail_contact(this.private_data.id_contact)
                .then(response => {
                    this.tags = response.data.data.tags;
                })
                .catch(err => {
                    console.log('tags -> ',err);
                })
            }
        },
         getBreach(id){
            AdvancedService.getBreach(id)
            .then(response => {
                this.adv_exposed = response.data.data;
                // console.log('hasil', response.data.data);
            })
            .catch(e => {
                this.message = e.response.data.data;
            });
        },
        getWebsiteDetail(){
            if (this.webinfo?.id_web_info) {
                WebsiteService.getWebInfoDetail(this.webinfo.id_web_info)
                .then(response => {
                        this.subdomain = response.data.data.subdomain.subdomain;
                    })
                    .catch(err => {
                        console.log(err);
                });
            }
        },

        loadMedia(){
            this.media = []
            TargetService.getRelatedImage(this.id)
            .then(response => {
                response.data.data.forEach(element => {
                    if (element.source != 'instagram_vid') {
                        this.media.push(element);
                    }
                });
            })
            .catch(err => {
                console.log('load media -> ',err);
            })
        },
        getImage(name, path){
            return process.env.VUE_APP_BASE_API_URL_OSINT + 'stream-img?name='+name+'&path='+path
        },
        selectImage(val){
            if (this.selectelement.image.list.includes(val)) {
                let idx = this.selectelement.image.list.indexOf(val);
                this.selectelement.image.list.splice(idx, 1);
            }else{
                this.selectelement.image.list.push(val)
            }
        },
        getUserTimelineTwitter(){
            if(this.twitter){
                TwintService.getTimelineElastic(this.elastic, this.twitter.account)
                .then(response => {
                    this.created_at_timeline_twitter = response.data._source.created_at;
                    this.account_twitter = response.data._source.username
                    var x = response.data._source.timeline.slice(0,50);
                    this.timeline = [];
                    x.forEach((val) => {
                    const data = {
                        type: 'twitter',
                        date: val.date,
                        link: val.link,
                        caption: val.tweets,
                        location: val.place,
                    };
                        this.timeline.push(data);
                    });
                this.getUserTimelineInstagram();
                })
                .catch(err => {
                    console.log('tw timeline -> ',err);
                });
            } 
        },

        getNews(){
        this.news= [];
            NewsService.getNewsByID(this.id)
            .then(response => {
                response.data.data.forEach(val => {
                    let data = {
                        "id_news": val.id_news,
                        "author": val.author,
                        "content": val.content,
                        "image": val.image,
                        "published_at": val.published_at,
                        "source": val.source,
                        "title": val.title,
                        "sentiment": val.sentiment_analysis,
                        "url": val.url,
                    }
                    this.news.push(data)
                });
            })
            .catch(err => {
                console.log('news target -> ',err);
            });
        },
        
        getSource(){
            const clr = ["#EF4444","#60A5FA","#34D399","#EAB308","#818CF8","#EC4899","#14B8A6","#F97316","#F43F5E","#38BDF8","#71717A"]
            const darkclr = ["#991b1b","#1e40af","#065f46","#a18401","#5b21b6","#9d174d","#147066","#af4b04","#c41432","#0b6d99", "#1f2937"]
            this.colorsSource = this.theme == "dark" ? darkclr : clr;
            this.newsSource = [];
            this.labelsSource = [];
            this.seriesSource = [];
            const selectlist = this.selectelement.news.list;
            const count = {};
            let otherCount = 0;
            let otherLabel = [];
            selectlist.forEach(element => {
                count[element.source] = (count[element.source] || 0) + 1;
            });
            Object.entries(count).forEach(([k,v]) => {
                this.newsSource.push({"source" : k, "count" : v});
            });
            this.newsSource.forEach((el, idx) => {
                if (idx < 10) {
                    // console.log('source', el.source);
                    this.labelsSource.push(el.source);
                    this.seriesSource.push(el.count);
                }
                if (idx > 9) {
                    otherCount += el.count;
                }
            });
            if (otherCount > 0) {
                otherLabel.push('other source');
                this.labelsSource.push(otherLabel)
                this.seriesSource.push(otherCount)
            }
        },

        getSentiment(){
            this.newsSentiment = [];
            this.labelsSentiment = [];
            this.seriesSentiment = [];
            this.colorsSentiment = [];
            const selectlist = this.selectelement.news.list;
            const count = {};
            selectlist.forEach(element => {
                count[element.sentiment] = (count[element.sentiment] || 0) + 1;
            });
            Object.entries(count).forEach(([k,v]) => {
                this.newsSentiment.push({"sentiment" : k, "count" : v, "percentage": ((v / selectlist.length) * 100).toFixed(2)});
            });
            this.newsSentiment.forEach(el => {
                this.labelsSentiment.push(el.sentiment);
                this.seriesSentiment.push(el.count);
                if (el.sentiment == 'nuetral') {
                    this.colorsSentiment.push(this.theme == 'dark' ? "#0b6d99" : "#38BDF8")
                }else if(el.sentiment == 'positive'){
                    this.colorsSentiment.push(this.theme == 'dark' ? "#065f46" : "#34D399")
                }else {
                    this.colorsSentiment.push(this.theme == 'dark' ? "#991b1b" : "#EF4444")
                }
            });
            // if (this.selectelement.news.show) {
            //     this.$refs.senti.refresh();
            //     this.$refs.sentiprint.refresh();
            //     this.$refs.source.refresh();
            //     this.$refs.sourceprint.refresh();
            // }
        },

        getUserTimelineInstagram(){
            if(this.instagram){
                InstaService.getTimelineElastic(this.elastic, this.instagram.account)
                .then(response => {
                    this.created_at_timeline_instagram = response.data._source.created_at;
                    this.account_instagram = response.data._source.username
                    var x = response.data._source.timeline.slice(0,50);
                    x.forEach((val) => {
                    const data = {
                        type: 'instagram',
                        date: val.taken_at,
                        link: 'https://www.instagram.com/p/'+val.code,
                        caption: val.caption_text,
                        location: {},
                    };
                        this.timeline.push(data);
                    });
                    this.sortingArray();
                })
                .catch(err => {
                    console.log('ig timeline -> ',err);
                });
            }
        },
        selectTimeline(val){
            if (this.selectelement.timeline.list.includes(val)) {
                let idx = this.selectelement.timeline.list.indexOf(val);
                this.selectelement.timeline.list.splice(idx, 1);
            }else{
                this.selectelement.timeline.list.push(val);
            }
        },
        selectNews(val){
            if (this.selectelement.news.list.includes(val)) {
                let idx = this.selectelement.news.list.indexOf(val);
                this.selectelement.news.list.splice(idx, 1);
                this.base64img_news.splice(idx, 1);
                this.getSource();
                this.getSentiment();
            }else{
                this.selectelement.news.list.push(val);
                this.urlToBase64(val.image);
                this.getSource();
                this.getSentiment();
            }
            // this.$refs.senti.refresh();
            // this.$refs.sentiprint.refresh();
            // this.$refs.source.refresh();
            // this.$refs.sourceprint.refresh();
        },

        sortingArray(){
            const array = this.timeline;
            const sortedArray  = array.sort((a,b) => new moment(b.date).format('YYYYMMDDhhmmss') - new moment(a.date).format('YYYYMMDDhhmmss'));
            this.timeline = sortedArray.slice(0,49);
        },
        formatDate(value){
            return moment(value).format("DD MMMM YYYY, hh:mm");
        },
        // async getTargetDetail(){
        //     this.loadingnew = true,
        //     await TargetService.getDetailTarget(this.id)
        //     .then(response => {
        //         this.loadingnew = false;
        //         this.target = response.data.data;
        //         var json = JSON.parse('['+this.target.relation_profile+']');
        //         json.forEach((val) => {
        //             const data_nodes = {"data":{"id": val.id, "label":val.name, "parent_node": "relation", "id_target": val.id}};
        //             this.config.elements.nodes.push(data_nodes);
        //             const data_edges = {"data":{"source":val.id, "target": '2rp'}};
        //             this.config.elements.edges.push(data_edges);
        //         });
        //     })
        //     .catch(err => {
        //         this.loadingnew = false;
        //         console.log(err);
        //     });
        //     this.dataRelation = true;
        // },


        async getWordCloud(){
            if (this.twitter) {
                await TwintService.getWordCloudElastic(this.elastic, this.twitter.account)
                .then(response => {
                    var word_cloud = response.data._source.wordcloud;
                    word_cloud.forEach((val, index) => {
                        const data_wc_nodes = {"data":{"id": "wc-"+index, "label":val.word, "parent_node": "word"}, "grabbable": false};
                        this.config.elements.nodes.push(data_wc_nodes);
                        const data_wc_edges = {"data":{"source":"wc-"+index, "target": '3wc'}, "grabbable": false};
                        this.config.elements.edges.push(data_wc_edges);
                    });
                })
                .catch(err => {
                    console.log(err);
                })
                this.dataWordCloud = true
            }
        },
        async getTopFollow(){
            if (this.twitter) {
                await TwintService.getFollowElastic(this.elastic, this.twitter.account)
                .then(response => {
                var followers = response.data._source.followers;
                var following = response.data._source.following;
        
                followers.forEach((val, index) => {
                    const data_flwr_nodes = {"data":{"id": "flwr-"+index, "label":val.username, "parent_node": "follower"}, "grabbable": false};
                    this.config.elements.nodes.push(data_flwr_nodes);
                    const data_flwr_edges = {"data":{"source":"flwr-"+index, "target": '5flwr'}, "grabbable": false};
                    this.config.elements.edges.push(data_flwr_edges);
                });
        
                following.forEach((val, index) => {
                const data_flwng_nodes = {"data":{"id": "flwng-"+index, "label":val.username, "parent_node": "following"}, "grabbable": false}
                    this.config.elements.nodes.push(data_flwng_nodes);
                    const data_flwng_edges = {"data":{"source":"flwng-"+index, "target": '4flwng'}, "grabbable": false};
                    this.config.elements.edges.push(data_flwng_edges);
                });
                })
                .catch(err => {
                    console.log(err);
                })
                this.dataFollow = true;
            }
        },
        async getTopMention(){
            if (this.twitter) {
                await TwintService.getMentionsElastic(this.elastic, this.twitter.account)
                .then(response => {
                var topmention = response.data._source.topmention;
                topmention.forEach((val, index) => {
                    const data_top_nodes = {"data":{"id": "top-"+index, "label":val.user_mention, "parent_node": "topmention"}, "username":val.username, "grabbable": false}
                    this.config.elements.nodes.push(data_top_nodes);
                    const data_top_edges = {"data":{"source":"top-"+index, "target": '6mention'}, "grabbable": false};
                    this.config.elements.edges.push(data_top_edges);
                });
        
                })
                .catch(err => {
                    console.log(err);
                })
                this.dataMention = true;
            }
        },
        preConfig(cytoscape) {
            cytoscape.use(cola)
        },
        async afterCreated(cy=null) {
            if (cy !== null) {
                this.cy = cy
            } else {
                cy = this.cy
            }
            await cy
            cy.load
            cy.layout(this.config.layout).run();
            cy.userZoomingEnabled(false)
            cy.center()
            cy.fit()
            
        },

        async getRelation(){
            let data = {
                'id_target' : this.id
            }
            await TargetService.getRelatedTarget(data)
            .then(response => {
                // console.log('degre relation', response.data.degree);
                this.degrees    = response.data.degree;
                this.betweeness = response.data.betweeness;
                this.closeness  = response.data.closeness;
                response.data.nodes.forEach(el => {
                    if (el.id != this.id) {
                        const data_nodes = {"data":{"id": el.id, "label":el.name, "parent_node": this.id, "id_target": el.id}, "grabbable": false};
                        this.configSNA.elements.nodes.push(data_nodes);
                        let style_node = {
                            selector: "node[id_target='"+el.id+"']",
                            style: { 
                            "width": "70px", 
                            "height": "70px", 
                            "content": "data(label)", 
                            'background-image': process.env.VUE_APP_BASE_API_URL_IMAGE+el.image,
                            'background-width' : '70px',
                            'background-height' : '70px',
                            }
                        }
                        this.configSNA.style.push(style_node);
                    }
                    if (el.name === Object.keys(this.degrees)[0]) {
                        let text_style_degree = {
                            selector: "node[id_target='"+el.id+"']",
                            style: { 
                            "text-transform": "uppercase", 
                            "color": "#555555", 
                            "font-size": "16px",
                            "text-valign": "bottom", 
                            "text-halign": "center",  
                            "text-outline-color": "#0067AC", 
                            "text-outline-width": "2px", 
                            "color": "#fff", 
                            "overlay-padding": "6px", 
                            "z-index": "10",
                            "border-color": "#0067AC",
                            "border-opacity": "1",
                            "border-width": "5px"
                            }
                        }
                        this.configSNA.style.push(text_style_degree);
                    }
                    if (el.name === Object.keys(this.betweeness)[0]) {
                        let text_style_betweeness = {
                            selector: "node[id_target='"+el.id+"']",
                            style: { 
                            "text-transform": "uppercase", 
                            "color": "#555555", 
                            "font-size": "16px",
                            "text-valign": "bottom", 
                            "text-halign": "center",  
                            "text-outline-color": "#F1B44C", 
                            "text-outline-width": "2px", 
                            "color": "#fff", 
                            "overlay-padding": "6px", 
                            "z-index": "10",
                            "border-color": "#F1B44C",
                            "border-opacity": "1",
                            "border-width": "5px"
                            }
                        }
                        this.configSNA.style.push(text_style_betweeness);
                    }
                    if (el.name === Object.keys(this.closeness)[0]) {
                        let text_style_closeness = {
                            selector: "node[id_target='"+el.id+"']",
                            style: { 
                            "text-transform": "uppercase", 
                            "color": "#555555", 
                            "font-size": "16px",
                            "text-valign": "bottom", 
                            "text-halign": "center",  
                            "text-outline-color": "#34C38F", 
                            "text-outline-width": "2px", 
                            "color": "#fff", 
                            "overlay-padding": "6px", 
                            "z-index": "10",
                            "border-color": "#34C38F",
                            "border-opacity": "1",
                            "border-width": "5px"
                            }
                        }
                        this.configSNA.style.push(text_style_closeness);
                    }
                });
                response.data.edges.forEach(el => {
                    const data_edges = {"data":{"edge_type":"relation","source":el[1].id_edge, "target": el[0].id_edge}};
                    this.configSNA.elements.edges.push(data_edges);
                });
            })
            .catch(err => {
                console.log(err);
            });
            // this.loading = false;
            this.dataRelationSNA = true;
        },

        preConfigSNA(cytoscape) {
        cytoscape.use(cola)
        },
        async afterCreatedSNA(cy) {
            cy.userZoomingEnabled(false);
        },

        clearTimeline(){
            this.selectelement.timeline.list = [];
        },
        
        clearNews(){
            this.selectelement.news.list = [];
        },

        clearRelationImage(){
            this.selectelement.image.list = [];
        },

        errorImage(val, idx){
            console.log('err img =>> ',idx + val);
        },

        formatMonth(value){
             if(value == 1){
                var bulan = "Jan";
             } else if(value == 2){
                var bulan = "Feb";
             }  else if(value == 3){
                var bulan = "Mar";
             }  else if(value == 4){
                var bulan = "Apr";
             }  else if(value == 5){
                var bulan = "Mei";
             }  else if(value == 6){
                var bulan = "Jun";
             }  else if(value == 7){
                var bulan = "Jul";
             }  else if(value == 8){
                var bulan = "Agu";
             }  else if(value == 9){
                var bulan = "Sep";
             } else if(value == 10){
                var bulan = "Okt";
             }  else if(value == 11){
                var bulan = "Nov";
             } else if(value == 12){
                var bulan = "Des";
             }
            return bulan;
        },

        urlToBase64(url){
            const data = {
                'urlimage' : url
            }
            return SherlockService.urlToBase64(data)
            .then(response => {
                this.base64img_news.push('data:image/jpeg;base64,'+response.data.output)
            })
            .catch(err => {
                console.log(err);
            })
        }
    },
    filters: {
        upper(value){
        if(!value) return ''
            value = value.toString()
        return value.toUpperCase()
        },
        lower(value){
        if(!value) return ''
            value = value.toString()
        return value.toLowerCase()
        }
    },
    async beforeMount(){
        await this.getTargetDetail();
        await this.getPreferences();
        await this.getRelation();
        await this.loadMedia();
        await this.getNews();
        await this.getSentiment();
    },
};
</script>
<style>
hr.dashed {
    border-top: 1px dashed #74788d;
}
@media print {
    * {
        -webkit-print-color-adjust: exact;
    }
    
}
</style>